(function() {
    'use strict';

    angular
        .module('gatewayApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'angular-loading-bar',
            'ncy-angular-breadcrumb',
            'bckrueger.angular-currency',
		    'ui.dashboard',
		    'file-model',
		    'ui.mask',
		    'as.sortable',
		    'ngIdle',
		    'ae-datetimepicker',
            'ngCordova',
            'fileLogger'
	    ])
        .run(["$templateCache", function($templateCache) {$templateCache.put("multiple-autocomplete-tpl.html","<div ng-class=\"disabledClass\" class=\"ng-ms form-item-container\" >\r\n    <ul class=\"list-inline\">\r\n        <li ng-repeat=\"item in modelArr\">\r\n			<span ng-if=\"displayColumn == undefined || displayColumn == \'\'\">\r\n				{{item}} <span class=\"remove\" ng-click=\"removeAddedValues(item)\">\r\n                <i class=\"glyphicon glyphicon-remove\"></i></span>&nbsp;\r\n			</span>\r\n            <span ng-if=\"displayColumn != undefined && displayColumn != \'\'\">\r\n				{{item[displayColumn]}} <span class=\"remove\" ng-click=\"removeAddedValues(item)\">\r\n                <i class=\"glyphicon glyphicon-remove\"></i></span>&nbsp;\r\n			</span>\r\n        </li>\r\n        <li>\r\n            <input name=\"{{name}}\" ng-model=\"inputValue\" placeholder=\"\" ng-keydown=\"keyParser($event)\"\r\n    ng-show=\"controlEnabled\"              err-msg-required=\"{{errMsgRequired}}\"\r\n                   ng-focus=\"onFocus()\" ng-blur=\"onBlur()\" ng-required=\"!modelArr.length && isRequired\"\r\n                    ng-change=\"onChange()\">\r\n        </li>\r\n    </ul>\r\n</div>\r\n<div class=\"autocomplete-list\" ng-show=\"isFocused || isHover\" ng-mouseenter=\"onMouseEnter()\" ng-mouseleave=\"onMouseLeave()\">\r\n    <ul ng-if=\"displayColumn == undefined || displayColumn == \'\'\">\r\n        <li ng-class=\"{\'autocomplete-active\' : selectedItemIndex == $index}\"\r\n            ng-repeat=\"suggestion in suggestionsArr | filter : inputValue | filter : alreadyAddedValues\"\r\n            ng-click=\"onSuggestedItemsClick(suggestion)\" ng-mouseenter=\"mouseEnterOnItem($index)\">\r\n            {{suggestion}}\r\n        </li>\r\n    </ul>\r\n    <ul ng-if=\"displayColumn != undefined && displayColumn != \'\'\">\r\n        <li ng-class=\"{\'autocomplete-active\' : selectedItemIndex == $index}\"\r\n            ng-repeat=\"suggestion in suggestionsArr | filter : inputValue | filter : alreadyAddedValues\"\r\n            ng-click=\"onSuggestedItemsClick(suggestion)\" ng-mouseenter=\"mouseEnterOnItem($index)\">\r\n   <i ng-if=\"displayColumn2 == undefined || objectPropertyCodeName == \'\'\">\r\n           {{suggestion[displayColumn]}}\r\n        </i>  <i ng-if=\"displayColumn2 != undefined && objectPropertyCodeName != \'\'\">\r\n           {{suggestion[displayColumn]}} :: {{suggestion[displayColumn2]}} \r\n        </i></li>\r\n    </ul>\r\n</div>");}])
        .directive('csplMultipleAutocomplete', ['$filter','AppLookup', 'GlobalValues', '$rootScope', '$sessionStorage', 'DateUtils',
            function ($filter,AppLookup, GlobalValues, $rootScope, $sessionStorage, DateUtils) {
                return {
                    restrict: 'EA',
                    scope : {
                        suggestionsArr : '=?',
                        modelArr : '=ngModel',
                        beforeSelectItem : '=?',
                        afterSelectItem : '=?',
                        beforeRemoveItem : '=?',
                        afterRemoveItem : '=?',
                        filterValue : '=',
                        lookupName: '@',
                        displayColumn : '@',
                        displayColumn2 : '@',
                        controlEnabled : "="
                    },
                    templateUrl: 'multiple-autocomplete-tpl.html',

                    link : function(scope, element, attr){
                	scope.disabledClass= '';
                        scope.selectedItemIndex = 0;
                        scope.name = attr.name;
                        scope.isRequired = attr.required;
                        scope.errMsgRequired = attr.errMsgRequired;
                        scope.isHover = false;
                        scope.isFocused = false;

                        if(scope.controlEnabled==null || scope.controlEnabled=="")
                            scope.controlEnabled = true;

                        if(scope.controlEnabled=="false" || scope.controlEnabled==false)
                             scope.disabledClass = 'div-disabled';

                        scope.$watch("controlEnabled",function(value){
                            if(value=="false" || value==false)
                             scope.disabledClass = 'div-disabled';
                         else
                             scope.disabledClass = '';
                        });

                        var getSuggestionsList = function () {
                            scope.suggestionsArr  = AppLookup.getLookupValue(scope.lookupName, "");
                        };

                        if(scope.suggestionsArr == null || scope.suggestionsArr == ""){
                            if(scope.lookupName != null && scope.lookupName != "")
                                getSuggestionsList();
                            else{
                                console.log("*****There is no suggestion list added ****");
                            }
                        }

                        if(scope.controlEnabled ==null || scope.controlEnabled ==""){
                            scope.controlEnabled = true;
                        }

                        scope.$watch("filterValue",function(value){
                	    if(value != null && value != "") {
                	    if(scope.modelArr != null && scope.modelArr != "") {
                		var index =0;
                		for(index =0 ; index< value.length; index++){
                		var itemIndex = 0
                		for (itemIndex =0; itemIndex < scope.suggestionsArr.length; itemIndex++)
                		    if(scope.suggestionsArr[itemIndex][scope.displayColumn] == value[index][scope.displayColumn])
                                {
                                scope.suggestionsArr.splice(itemIndex, 1);
                                var removeIndex =0;
                                for (removeIndex =0; removeIndex < scope.modelArr.length; removeIndex++)
                    		 if(scope.modelArr[removeIndex][scope.displayColumn] == value[index][scope.displayColumn])
                                    {
                    		     var item = scope.modelArr[removeIndex][scope.displayColumn];
                                    if(scope.beforeRemoveItem && typeof(scope.beforeRemoveItem) == 'function')
                                        scope.beforeRemoveItem(item);

                                    scope.modelArr.splice(removeIndex, 1);

                                    if(scope.afterRemoveItem && typeof(scope.afterRemoveItem) == 'function')
                                        scope.afterRemoveItem(item);
                                }
                                }
                            }
                	    }
                	    }

                	},true);



                        if(scope.modelArr == null || scope.modelArr == ""){
                            scope.modelArr = [];
                        }
                        scope.onFocus = function () {
                            scope.isFocused=true
                        };

                        scope.onMouseEnter = function () {
                            scope.isHover = true
                        };

                        scope.onMouseLeave = function () {
                            scope.isHover = false;
                        };

                        scope.onBlur = function () {
                            scope.isFocused=false;
                        };

                        scope.onChange = function () {
                            scope.selectedItemIndex = 0;
                        };

                        scope.keyParser = function ($event) {
                            var keys = {
                                38: 'up',
                                40: 'down',
                                8 : 'backspace',
                                13: 'enter',
                                9 : 'tab',
                                27: 'esc'
                            };
                            var key = keys[$event.keyCode];
                            if(key == 'backspace' && scope.inputValue == ""){
                                if(scope.modelArr.length != 0){
                                    scope.removeAddedValues(scope.modelArr[scope.modelArr.length-1]);
                                    // scope.modelArr.pop();
                                }
                            }
                            else if(key == 'down'){
                                var filteredSuggestionArr = $filter('filter')(scope.suggestionsArr, scope.inputValue);
                                filteredSuggestionArr = $filter('filter')(filteredSuggestionArr, scope.alreadyAddedValues);
                                if(scope.selectedItemIndex < filteredSuggestionArr.length -1)
                                    scope.selectedItemIndex++;
                            }
                            else if(key == 'up' && scope.selectedItemIndex > 0){
                                scope.selectedItemIndex--;
                            }
                            else if(key == 'esc'){
                                scope.isHover = false;
                                scope.isFocused=false;
                            }
                            else if(key == 'enter'){
                                var filteredSuggestionArr = $filter('filter')(scope.suggestionsArr, scope.inputValue);
                                filteredSuggestionArr = $filter('filter')(filteredSuggestionArr, scope.alreadyAddedValues);
                                if(scope.selectedItemIndex < filteredSuggestionArr.length)
                                    scope.onSuggestedItemsClick(filteredSuggestionArr[scope.selectedItemIndex]);
                            }
                        };

                        scope.onSuggestedItemsClick = function (selectedValue) {
                            if(scope.beforeSelectItem && typeof(scope.beforeSelectItem) == 'function')
                                scope.beforeSelectItem(selectedValue);

                            scope.modelArr.push(selectedValue);

                            if(scope.afterSelectItem && typeof(scope.afterSelectItem) == 'function')
                                scope.afterSelectItem(selectedValue);
                            scope.inputValue = "";
                        };

                        var isDuplicate = function (arr, item) {
                            var duplicate = false;
                            if(arr == null || arr == "")
                                return duplicate;

                            for(var i=0;i<arr.length;i++){
                                duplicate = angular.equals(arr[i], item);
                                if(duplicate)
                                    break;
                            }
                            return duplicate;
                        };

                        scope.alreadyAddedValues = function (item) {
                            var isAdded = true;
                            isAdded = !isDuplicate(scope.modelArr, item);
                            // if(scope.modelArr != null && scope.modelArr !=
							// ""){
                            // isAdded = scope.modelArr.indexOf(item) == -1;
                            // console.log("****************************");
                            // console.log(item);
                            // console.log(scope.modelArr);
                            // console.log(isAdded);
                            // }
                            return isAdded;
                        };

                        scope.removeAddedValues = function (item) {
                            if(scope.modelArr != null && scope.modelArr != "") {
                                var itemIndex = scope.modelArr.indexOf(item);
                                if (itemIndex != -1) {
                                    if(scope.beforeRemoveItem && typeof(scope.beforeRemoveItem) == 'function')
                                        scope.beforeRemoveItem(item);

                                    scope.modelArr.splice(itemIndex, 1);

                                    if(scope.afterRemoveItem && typeof(scope.afterRemoveItem) == 'function')
                                        scope.afterRemoveItem(item);
                                }
                            }
                        };

                        scope.mouseEnterOnItem = function (index) {
                            scope.selectedItemIndex = index;
                        };
                    }
                };
            }
        ])
		.directive("fileread", [function () {
		    return {
		        scope: {
		            fileread: "="
		        },
		        link: function (scope, element, attributes) {
		            element.bind("change", function (changeEvent) {
		                var reader = new FileReader();
		                reader.onload = function (loadEvent) {
		                    scope.$apply(function () {
		                        scope.fileread = changeEvent.target.files[0];
		                    });
		                }
		                reader.readAsDataURL(changeEvent.target.files[0]);
		            });
		        }
		    }
		}])       
       .directive('csplAch', ['AppLookup', '$rootScope', '$sessionStorage', function(AppLookup, $rootScope, $sessionStorage) {
            return {
                template: '<input type="text" role="combobox" id="{{controlId}}" autocomplete="off" ng-model="controlModel" ng-disabled="controlDisabled || overrideDisabled"  ng-change="updateModel()" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" typeahead-append-to-body="appendToBody" typeahead-popup-template-url="app/cspl-ach-dropdown-template.html" uib-typeahead="lookupName as customTypeAcheadLabel(lookupName, displayColumn) for lookupName in lookupValues | filter:$viewValue | limitTo:50" class="form-control" typeahead-editable="false" typeahead-min-length="1" ng-attr-style="background:url({{imageurl}}) no-repeat scroll 5px 5px; background-position: bottom 5px right 5px; background-color:{{bgColor}}; border-color:{{boColor}}; color:{{colorValue}}; padding-right:30px; margin-bottom: 8px;" placeholder="{{controlPlaceHolder}}"><span ng-show="Error != null && Error != \'\'" class="help-block-error" >{{Error}}</span><span ng-show="errorText != null && errorText!= \'\' && showErrorText" class="help-block-warning-error arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 3px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black; z-index: 1000; top: 25px; white-space: nowrap;">{{errorText}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlRequired: '=',
                    controlDisabled: "=",
                    controlValueChange: '=',
                    form: '=',
                    controlId: '@',
                    appendToBody: '@',
                    lookupName: '@',
                    displayColumn: '@',
                    filterValue: '@',
                    helpText: '@',
                    themeType: '@',
                    controlModified:'=',
                    controlPlaceHolder:'@',
                    showErrorText: '=',
                    defaultValue: '=' 
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        var previousFilter = "";
                        // typeahead-min-length="0"

                        $scope.boColor = "#BB8557";
                        $scope.overrideDisabled = false;

                        if ($scope.appendToBody == null) {
                            $scope.appendToBody = false;
                        }


                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }
                        
                        $scope.customTypeAcheadLabel = function(lookup, displayColumn) {
                            if (lookup == null || lookup == undefined)
                               return;

                            $scope.displayColumnArr = displayColumn.split(","); 
                            $scope.numberOfColumns = $scope.displayColumnArr.length; 
                            if (lookup[$scope.displayColumnArr[0]] == '' || lookup[$scope.displayColumnArr[0]] == undefined) {
                                return '';
                             }
                             
                            var label = lookup[$scope.displayColumnArr[0]];
                            return label;
                        }

                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == "true" || value == true)) {
                                // element.attr('required', true);
                            	// attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                // element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                    $scope.Error = "";
                                    $scope.errorText = "";
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled || $scope.overrideDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#BB8557";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                                if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel == null || $scope.controlModel == "" || $scope.controlModel== undefined)) {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                        $scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel != null && $scope.controlModel != "" && $scope.controlModel!=undefined)){
                                     if ($scope.form != null) {
                                         $scope.form.$setValidity(attributes.controlId + "achrequired", true);   
                                     }
                                    $scope.Error = "";
                                    if ($scope.controlDisabled) {
                                        $scope.bgColor = "#333333";
                                        if($scope.themeType=='light'){
                                            // $scope.bgColor = "#FFFFFF";
                                            $scope.boColor = "#BB8557";
                                        }
                                        if($scope.themeType=='light'){
                                            $scope.bgColor = "#E0E0E0";
                                        }
                                    } else {
                                        $scope.bgColor = "#0B0B0B";
                                        if($scope.themeType=='light'){
                                            $scope.bgColor = "#FEFAEE";
                                            $scope.boColor = "#BB8557";
                                        }
                                    }
                                    
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                        $scope.Error = ""
                                    }
                                    if ($scope.controlDisabled) {
                                        $scope.bgColor = "#333333";
                                        if($scope.themeType=='light'){
                                            $scope.bgColor = "#E0E0E0";
                                            $scope.boColor = "#C2C2C2";
                                        }
                                    } else {
                                        $scope.bgColor = "#0B0B0B";
                                        if($scope.themeType=='light'){
                                            $scope.bgColor = "#FFFFFF";
                                            $scope.boColor = "#C2C2C2";
                                        }
                                    }
                                    $scope.boColor = "#595959";
                                    if($scope.themeType=='light'){
                                        $scope.boColor = "#C2C2C2";
                                    }
                                }
                            }
                            if ($scope.controlModel != null && $scope.controlModel != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if ( (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", false);
                                }
                                $scope.boColor = "#BB8557";
                               
                            } else if ( (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && !($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                            		$scope.bgColor = "#FEFAEE";
                            	}
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                            $scope.errorText = "";
                        }
                        
                        $scope.onBlur = function(value){
                            if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true")) {
                                $scope.boColor = "#BB8557";
                                if(value==undefined || value=='' || value==null){
                                    /*
                                     * if($scope.showError!="false"){
                                     * $scope.Error = "This field cannot be left
                                     * blank"; }
                                     */
                                    if($scope.showErrorText!=true){
                                        $scope.Error = "This field cannot be left blank";
                                    }
                                    $scope.errorText = "This field cannot be left blank";
                                    $scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                            if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value == null || value == "" || value== undefined)) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value != null && value != "" && value!=undefined)){
                                 if ($scope.form != null) {
                                     $scope.form.$setValidity(attributes.controlId + "achrequired", true);   
                                     $scope.boColor = "#BB8557";
                                 }
                                $scope.Error = "";
                                $scope.errorText = "";
                                if ($scope.controlDisabled || $scope.overrideDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	// $scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#BB8557";
                                    }
                                    if($scope.themeType=='light'){
                                		$scope.bgColor = "#E0E0E0";
                                	}
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    	$scope.boColor = "#BB8557";
                                    }
                                }
                                
                            } else {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                    $scope.Error = "";
                                    $scope.errorText = "";
                                }
                                if ($scope.controlDisabled || $scope.overrideDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }

                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                            $scope.imageurl = "assets/images/search.png";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                            $scope.imageurl = "assets/images/search.png";
                        }
                        if ($scope.themeType == 'light'){
                            $scope.imageurl = "assets/images/search.png";
                        	$scope.colorValue = '#262626';	
                        }

                        if (attributes.filterValue == null) {
                            $scope.lookupValues = AppLookup.getLookupValue($scope.lookupName, "");
                            // $scope.controlModel =
							// {shortName:'SudarshanIndia'};
                        } else {
   
                            if(($scope.lookupName!=undefined && $scope.lookupName!=null && $scope.lookupName!='') && ($scope.lookupName=='fcyCurrencyPair' || $scope.lookupName=='orderCurrencyPair')){
                                                         
attributes.$observe('filterValue', function(value) {
    if (previousFilter == "") {
        previousFilter = value;
    } else if (previousFilter != value && previousFilter != null && previousFilter != "") {
        previousFilter = value;
        $scope.controlModel = null;
    }

    var promise = AppLookup.getLookupValue($scope.lookupName, $scope.filterValue);
    if (!angular.isUndefined(promise) && _.keys(promise) != "") {
        promise.$promise.then(function(result) {
            $scope.lookupValues = result;

            if (result != null && result.length > 0) {
                if ($scope.controlModel != null && $scope.controlModel != undefined) {
                    // ✅ Check if current controlModel exists in list
                    var existingItem = result.find(function(item) {
                        return item.id === $scope.controlModel.id; // 🔁 change to your key
                    });

                    // if (existingItem) {
                    //     // ✅ Found — re-assign to refresh binding
                    //     $scope.controlModel = existingItem;
                    // } else {
                        // ❌ Not found — check default value
                        selectDefaultOrFirst(result);
                   // }
                } else {
                    // No current model — check default value
                    selectDefaultOrFirst(result);
                }
            } else {
                $scope.lookupValues = null;
                $scope.controlModel = null;
            }
        });
    } else {
        $scope.lookupValues = null;
        $scope.controlModel = null;
    }
});
                            }else{
attributes.$observe('filterValue', function(value) {
                                if (previousFilter == "") {
                                    previousFilter = value;
                                } else if (previousFilter != value && previousFilter != null && previousFilter != "") {
                                    previousFilter = value;
                                    $scope.controlModel = null;
                                }
                                //$scope.lookupValues = AppLookup.getLookupValue($scope.lookupName, value);
                                var promise = AppLookup.getLookupValue($scope.lookupName, $scope.filterValue);
                                if (!angular.isUndefined(promise) && _.keys(promise)!="") {
                                    promise.$promise.then(function(result) {
                                        $scope.lookupValues = result;
                                        if (result!= "" && result.length == 1 
                                            && ($scope.controlModel == null || $scope.controlModel == undefined)
                                            && ($scope.lookupName == "validBranchDetailsForBank" || $scope.lookupName == "validStatusBranchesForBank")) {
                                            $scope.controlModel = result[0];
                                        }
                                    });
                                }else{
                                	$scope.lookupValues = null;
                                }
                            });
                        
                        }

// ✅ Helper function
function selectDefaultOrFirst(result) {
    if ($scope.defaultValue != null && $scope.defaultValue != undefined) {
        // Check if defaultValue exists in list
        var defaultItem = result.find(function(item) {
            return item.id === $scope.defaultValue.id; // 🔁 change to your key
        });

        if (defaultItem) {
            // ✅ Default found in list — select it
            $scope.controlModel = defaultItem;
        } else {
            // ❌ Default not in list — select first
            $scope.controlModel = result[0];
        }
    } else {
        // No default provided — select first
        $scope.controlModel = result[0];
    }
}
                        }
                        attributes.$observe('required', function(value) {
                        	if(value==null || value==undefined){
                        		// element.removeAttr('required');
                        		if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                        	}else{
                        		// attributes.$set("required", true);
                        		if ($scope.controlModel == null || $scope.controlModel == "" || $scope.controlModel == undefined) {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "achrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                        	
                        	}
                        });
                        /*
						 * $scope.getLookupValues = function(filterText){
						 * if($scope.loadDynamicData){ if(filterText!=null &&
						 * filterText!=undefined && filterText!=''){
						 * $timeout(function(){ $scope.lookupValues =
						 * AppLookup.getLookupValue($scope.lookupName,
						 * filterText, function(result){ console.log(result);
						 * return result; }); },0.0000); return
						 * $scope.lookupValues; } }else{ //do nothing return
						 * $scope.lookupValues; } }
						 */
                        
                        $rootScope.$on('gatewayApp:loadLookupComplete', function(event, result) {
                           // if ($scope.controlModel == null && result.length == 1 && ($scope.lookupName == "validBranchDetailsForBank" || $scope.lookupName == "validStatusBranchesForBank")) {
                           //      $scope.controlModel = result[0];
                           //  }
                        });
                        $scope.$watch('controlModified', function(value) {
                         if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                $scope.boColor = "#00B0F0";
                                
                            }
                        
                        })

                   }
                    return linkFunction;
                }
            };
        }])
        .directive('csplDtp', ['DateUtils', '$filter', '$timeout', function(DateUtils, $filter, $timeout) {
            var controllerName = 'dateEditCtrl';
            return {
                controller: function() {
                    this.popupOpen = false;
                    this.openPopup = function($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        this.popupOpen = true;
                    };
                },
                controllerAs: controllerName,
                template: '<div class="input-group" ng-disabled="controlDisabled"><input name="cspl-dtp" id="controlId" type="text" ng-disabled="controlDisabled" ng-attr-placeholder="{{controlPlaceHolder}}" autocomplete="off" class="form-control" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};color:{{colorValue}}; margin-bottom:8px;" uib-datepicker-popup="d!-M!-yyyy" datepicker-append-to-body="appendToBody" datepicker-options="{ minDate: controlMinDate, maxDate: controlMaxDate}" ng-model="controlModel" ui-mask="99-99-9999" ui-mask-placeholder="" ui-mask-placeholder-char="space" model-view-value="true" is-open="dateEditCtrl.popupOpen" /><span class="input-group-btn"><button type="button" tabindex="-1" ng-disabled="controlDisabled" class="btn btn-primary" ng-attr-style="border-color:{{boColor}}; background:{{bgColor}}; border-left:0.25px solid {{boColor}}; height:34px; margin-bottom:8px;" ng-click="dateEditCtrl.openPopup($event)" ><i class="glyphicon glyphicon-calendar"></i></button></span></div><span ng-show="Error != null && Error!= \'\'" class="help-block-error">{{Error}}</span><span ng-show="errorText != null && errorText!= \'\' && showErrorText" class="help-block-warning-error arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 3px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black; z-index: 1000; top: 25px; white-space: nowrap;">{{errorText}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                restrict: 'E',
                scope: {
                    controlMinDate: '=',
                    controlMaxDate: '=',
                    controlRequired: '=',
                    controlModel: '=',
                    controlDisabled: '=',
                    controlValueChange: '=',
                    appendToBody: '@',
                    form: '=',
                    controlEnterKey: '&',
                    controlLeaveKey: '&',
                    controlId: '@',
                    helpText: '@',
                    themeType: '@',
                    holidayList: '=',
                    showErrorText: '=',
                    orderEntryControl: '=',
                    controlPlaceHolder: '@',
                    controlModified:'='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";
                        // if($scope.controlMinDate==null || $scope.controlMinDate==undefined || $scope.controlMinDate==''){
                        // 	$scope.controlMinDate = new Date("1900-01-01");
                        // }
                        // if($scope.controlMaxDate==null || $scope.controlMaxDate==undefined || $scope.controlMaxDate==''){
                        // 	$scope.controlMaxDate = new Date("9999-12-31");
                        // }

                        element.bind("keydown keypress", function (event) {
        		            if(event.which === 13) {
        		            	$scope.$apply(function (){
        		            		$scope.$parent.$eval(attributes.controlEnterKey);
        		                });
        		
        		                event.preventDefault();
        		            }
        		        });

                        element.bind("change", function (event) {
                            $timeout(function (){
                                $scope.$parent.$eval(attributes.controlLeaveKey);
                            },200);

                            event.preventDefault();
                
                        });
                        if($scope.controlPlaceHolder == null || $scope.controlPlaceHolder ==undefined){
                        	
                        	$scope.controlPlaceHolder = 'dd-mm-yyyy';
                        }
                        if ($scope.appendToBody == null) {
                            $scope.appendToBody = false;
                        }

                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('dateEditCtrl.popupOpen', function(value){
                            if(value!=true){
                                $scope.onBlur($scope.controlModel);
                            }
                        })

                         $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	//attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    }
                                    $scope.Error = "";
                                    $scope.errorText = "";
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                                validateGivenDate($scope.controlModel);
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.Error = "";
                                $scope.errorText = "";
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                    $scope.bgColor = "#E0E0E0";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                    $scope.bgColor = "#FEFAEE";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                            }

                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if ( (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.boColor = "#BB8557";
                               
                            } else if ( (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && !($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                    $scope.bgColor = "#FEFAEE";
                                }
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		// $scope.Error = "This field cannot be left
									// blank";
                                    $scope.errorText = "Invalid date";
                                    if($scope.showErrorText!=true){
                                        $scope.Error = "Invalid date";
                                    }
                               		$scope.boColor = "#FF3737";
                                }else{
                                    validateGivenDate(value);
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                validateGivenDate(value);
                            }
                        }

                        function validateGivenDate(value){
                            if(value!=null && value!=undefined && value!=''){
                                $scope.errorText = "";
                                $scope.Error = "";
                                angular.forEach($scope.holidayList, function(value1){
                                    if(value1==DateUtils.convertLocalDateToServer(value)){
                                        $scope.errorText = "Date should not be a holiday";
                                        if($scope.showErrorText!=true){
                                            $scope.Error = "Date should not be a holiday";
                                        }
                                        if($scope.orderEntryControl!=null && $scope.orderEntryControl!=undefined && $scope.orderEntryControl==true){
                                            $scope.errorText = "Settlement date cannot be a holiday";
                                        }
                                        $scope.boColor = "#FF3737";
                                        if($scope.form!=null){
                                            $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                        }
                                    }
                                }) 
                                //validate max date and min date
                                var maxdateFromUI = angular.copy($scope.controlMaxDate);
                                if(maxdateFromUI==null || maxdateFromUI==undefined || maxdateFromUI==''){
                                    maxdateFromUI = new Date('9999-12-31');
                                }
                                var mindateFromUI = angular.copy($scope.controlMinDate);
                                if(mindateFromUI==null || mindateFromUI==undefined || mindateFromUI==''){
                                    mindateFromUI = new Date('1900-01-01');
                                }
                                var maxdate = DateUtils.convertLocalDateToServer(maxdateFromUI);
                                var mindate = DateUtils.convertLocalDateToServer(mindateFromUI);
                                if(moment(maxdate).isBefore(DateUtils.convertLocalDateToServer(value))){
                                    $scope.errorText = "Allowed last date is " + $filter('date')(new Date($scope.controlMaxDate),'dd-MMM-yyyy');
                                    if($scope.showErrorText!=true){
                                        $scope.Error = "Allowed last date is " + $filter('date')(new Date($scope.controlMaxDate),'dd-MMM-yyyy');
                                    }
                                    $scope.boColor = "#FF3737";
                                    if($scope.form!=null){
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);    
                                    }
                                }
                                if(moment(mindate).isAfter(DateUtils.convertLocalDateToServer(value))){
                                /*	MessageBox.openMessageBox("Alert", "date - " + $scope.controlMinDate );
                                	var dateDisplay = new Date($scope.controlMinDate).toLocaleDateString("en-US", { day: 'numeric' }) + "-"+
                                	date.toLocaleDateString("en-US", { month: 'short' }) + "-" +
                                	date.toLocaleDateString("en-US", { year: 'numeric' })
                                	MessageBox.openMessageBox("Alert", "date - " + dateDisplay );*/
                                	$scope.errorText = "Allowed earliest date is " + $filter('date')(new Date($scope.controlMinDate),'dd-MMM-yyyy');
                                    if($scope.showErrorText!=true){
                                        $scope.Error = "Allowed earliest date is " + $filter('date')(new Date($scope.controlMinDate),'dd-MMM-yyyy');
                                    }
                                    
                                    if($scope.orderEntryControl!=null && $scope.orderEntryControl!=undefined && $scope.orderEntryControl==true){
                                        var spotDate = new Date($scope.controlMinDate);
                                        spotDate.setDate(spotDate.getDate()-1);
                                        $scope.errorText = "Date must be greater than SPOT date " + $filter('date')(new Date(spotDate),'dd-MMM-yyyy');
                                    }
                                    $scope.boColor = "#FF3737";
                                    if($scope.form!=null){
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                }
                            }else{
                                $scope.errorText = "";
                                $scope.Error = "";
                                $scope.controlModel = null;
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                        	if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value == null || value == "" || value== undefined)) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value != null && value != "" && value!=undefined)){
                            	 if ($scope.form != null) {
                            		 $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                     $scope.boColor = "#BB8557";	 
                            	 }
                            	$scope.Error = "";
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	// $scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#BB8557";
                                    }
                                    if($scope.themeType=='light'){
                                		$scope.bgColor = "#E0E0E0";
                                	}
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    	$scope.boColor = "#BB8557";
                                    }
                                }
                                
                            } else {
                                $scope.updateModel();
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    $scope.Error = "";
                                    $scope.errorText = "";
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                	/*
									 * if($scope.themeType=='light'){
									 * $scope.bgColor = "#FEFAEE"; }
									 */
                                	
                                }
                            }
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                    $scope.bgColor = "#E0E0E0";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                    $scope.bgColor = "#FEFAEE";
                                }
                            }
                            if(value!=null && value!=undefined && value!=''){
                                $scope.errorText = "";
                                $scope.Error = "";
                                angular.forEach($scope.holidayList, function(value1){
                                    if(value1==DateUtils.convertLocalDateToServer(value)){
                                        $scope.errorText = "Date should not be a holiday";
                                        if($scope.showErrorText!=true){
                                            $scope.Error = "Date should not be a holiday";
                                        }
                                        if($scope.orderEntryControl!=null && $scope.orderEntryControl!=undefined && $scope.orderEntryControl==true){
                                            $scope.errorText = "Settlement date cannot be a holiday";
                                        }
                                        $scope.boColor = "#FF3737";
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                }) 

                                if($scope.errorText==""){
                                    validateGivenDate(value);
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                        }
                        if ($scope.themeType == 'light'){
                        	$scope.colorValue = '#262626';	
                        }

                        $scope.$watch('controlModified', function(value) {
                            if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                $scope.boColor = "#00B0F0";
                                
                            }
                        
                        });

                    }


                    return linkFunction;
                }
            };
        }])
        .directive('csplDtpWithoutErrorAndInfo', function() {
            var controllerName = 'dateEditCtrl';
            return {
                controller: function() {
                    this.popupOpen = false;
                    this.openPopup = function($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        this.popupOpen = true;
                    };
                },
                controllerAs: controllerName,
                template: '<div class="input-group" ng-disabled="controlDisabled"><input name="cspl-dtp" id="{{controlId}}" type="text" ng-disabled="controlDisabled" placeholder="dd-mm-yyyy" autocomplete="off" class="form-control" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};color:{{colorValue}}; margin-bottom:8px;" uib-datepicker-popup="d!-M!-yyyy" datepicker-append-to-body="appendToBody" datepicker-options="{ minDate: controlMinDate, maxDate: controlMaxDate}" ng-model="controlModel" ui-mask="99-99-9999" ui-mask-placeholder="" ui-mask-placeholder-char="space" model-view-value="true" is-open="dateEditCtrl.popupOpen" /><span class="input-group-btn"><button type="button" tabindex="-1" ng-disabled="controlDisabled" class="btn btn-primary" ng-attr-style="border-color:{{boColor}}; background:{{bgColor}}; border-left:0.25px solid {{boColor}}; height:34px; margin-bottom:8px;" ng-click="dateEditCtrl.openPopup($event)" ><i class="glyphicon glyphicon-calendar"></i></button></span></div>',
                restrict: 'E',
                scope: {
                    controlMinDate: '=',
                    controlMaxDate: '=',
                    controlRequired: '=',
                    controlModel: '=',
                    controlDisabled: '=',
                    controlValueChange: '=',
                    appendToBody: '@',
                    form: '=',
                    controlEnterKey: '&',
                    controlId: '@',
                    helpText: '@',
                    themeType: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";

                        element.bind("keydown keypress", function (event) {
        		            if(event.which === 13) {
        		            	$scope.$apply(function (){
        		            		$scope.$parent.$eval(attributes.controlEnterKey);
        		                });
        		
        		                event.preventDefault();
        		            }
        		        });
                        
                        if ($scope.appendToBody == null) {
                            $scope.appendToBody = false;
                        }

                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                         $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#FFC000";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    }
                                    $scope.Error = "";
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.Error = "";
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                            }

                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && ($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		// $scope.Error = "This field cannot be left
									// blank";
                            		$scope.Error = "Invalid date";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                        	if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value == null || value == "" || value== undefined)) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value != null && value != "" && value!=undefined)){
                            	 if ($scope.form != null) {
                            		 $scope.form.$setValidity(attributes.controlId + "dtprequired", true);	 
                            	 }
                            	$scope.Error = "";
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	// $scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#BB8557";
                                    }
                                    if($scope.themeType=='light'){
                                		$scope.bgColor = "#E0E0E0";
                                	}
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    	$scope.boColor = "#BB8557";
                                    }
                                }
                                
                            } else {
                                $scope.updateModel();
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    $scope.Error = "";
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                	/*
									 * if($scope.themeType=='light'){
									 * $scope.bgColor = "#FEFAEE"; }
									 */
                                	
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                        }
                        if ($scope.themeType == 'light'){
                        	$scope.colorValue = '#262626';	
                        }
                    }
                    return linkFunction;
                }
            };
        })
         .directive('csplDayMonth', function() {
            var controllerName = 'dateEditCtrl';
            return {
                controller: function() {
                    this.popupOpen = false;
                    this.openPopup = function($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        this.popupOpen = true;
                    };
                },
                controllerAs: controllerName,
                template: '<div class="input-group" ng-disabled="controlDisabled"><input name="cspl-day-month" id="controlId" type="text" ng-disabled="controlDisabled" placeholder="dd/MM" autocomplete="off" class="form-control" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};color:{{colorValue}}; margin-bottom:8px;" uib-datepicker-popup="d!/M!" datepicker-append-to-body="appendToBody" datepicker-options="{ minDate: controlMinDate, maxDate: controlMaxDate, maxMode: controlMaxMode}" ng-model="controlModel" ui-mask="99/99" ui-mask-placeholder="" ui-mask-placeholder-char="space" model-view-value="true" is-open="dateEditCtrl.popupOpen" /><span class="input-group-btn"><button type="button" tabindex="-1" ng-disabled="controlDisabled" class="btn btn-primary" ng-attr-style="border-color:{{boColor}}; background:{{bgColor}}; border-left:0.25px solid #0B0B0B; height:34px; margin-bottom:8px;" ng-click="dateEditCtrl.openPopup($event)" ><i class="glyphicon glyphicon-calendar"></i></button></span></div><span ng-show="Error != null" class="help-block-error">{{Error}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                restrict: 'E',
                scope: {
                    controlMinDate: '=',
                    controlMaxDate: '=',
                    controlRequired: '=',
                    controlModel: '=',
                    controlDisabled: '=',
                    controlValueChange: '=',
                    appendToBody: '@',
                    form: '=',
                    controlId: '=',
                    helpText: '@',
                    themeType: '@',
                    controlMaxMode:'='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";

                        if ($scope.appendToBody == null) {
                            $scope.appendToBody = false;
                        }

                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                            }

                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !(value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })

                         $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#FFC000";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		// $scope.Error = "This field cannot be left
									// blank";
                            		$scope.Error = "Invalid date";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                            if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else {
                                $scope.updateModel();
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    $scope.Error = "";
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                	/*
									 * if($scope.themeType=='light'){
									 * $scope.bgColor = "#FEFAEE"; }
									 */
                                	
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                        }
                        if ($scope.themeType == 'light'){
                        	$scope.colorValue = '#262626';	
                        }
                    }
                    return linkFunction;
                }
            };
        })
        .directive('csplDtpWithDay', function() {
            var controllerName = 'dateEditCtrl';
            return {
                controller: function() {
                    this.popupOpen = false;
                    this.openPopup = function($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        this.popupOpen = true;
                    };
                },
                controllerAs: controllerName,
                template: '<div class="input-group" ng-disabled="controlDisabled"><input name="cspl-dtp" id="controlId" type="text" ng-disabled="controlDisabled" placeholder="dd-mm-yyyy" autocomplete="off" class="form-control" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};color:{{colorValue}}; margin-bottom:8px;" uib-datepicker-popup="d!-M!-yyyy EEE" datepicker-append-to-body="appendToBody" datepicker-options="{ minDate: controlMinDate, maxDate: controlMaxDate}" readonly="true" ng-model="controlModel" ui-mask="99-99-9999  AAA" ui-mask-placeholder="" ui-mask-placeholder-char="space" model-view-value="true" is-open="dateEditCtrl.popupOpen" /><span class="input-group-btn"><button type="button" tabindex="-1" ng-disabled="controlDisabled" class="btn btn-primary" ng-attr-style="border-color:{{boColor}}; background:{{bgColor}}; border-left:0.25px solid #0B0B0B; height:34px; margin-bottom:8px;" ng-click="dateEditCtrl.openPopup($event)" ><i class="glyphicon glyphicon-calendar"></i></button></span></div><span class="help-block">{{ controlModel | date : "EEEE"}}</span><span ng-show="Error != null" class="help-block-error">{{Error}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                restrict: 'E',
                scope: {
                    controlMinDate: '=',
                    controlMaxDate: '=',
                    controlRequired: '=',
                    controlModel: '=',
                    controlDisabled: '=',
                    controlValueChange: '=',
                    appendToBody: '@',
                    form: '=',
                    controlId: '=',
                    helpText: '@',
                    themeType: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";

                        if ($scope.appendToBody == null) {
                            $scope.appendToBody = false;
                        }

                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                            }

                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !(value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })

                         $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#FFC000";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		// $scope.Error = "This field cannot be left
									// blank";
                            		$scope.Error = "Invalid date";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                            if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else {
                                $scope.updateModel();
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "dtprequired", true);
                                    $scope.Error = "";
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                        }
                        if ($scope.themeType == 'light'){
                        	$scope.colorValue = '#262626';	
                        }
                    }
                    return linkFunction;
                }
            };
        })
        .directive('csplMandatory', [function() {
            return {
                restrict: 'A',
                scope: {},
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        element.append('&nbsp;*&nbsp;&nbsp;');
                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplText', ['$compile', function($compile) {
            return {

                template: '<input type="{{controlInputType}}" maxlength="{{controlMaxlength}}" ng-class = "controlType" class="form-control" ng-model="controlModel" placeholder="{{controlPlaceHolder}}" ng-disabled="controlDisabled"  autocomplete="off" id="{{controlId}}" ng-change="updateModel()" ng-focus="onFocus()"  ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};text-transform: {{textTransformation}};" ng-pattern="{{controlPattern}}" /><span ng-show="Error != null" class="help-block-error">{{Error}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                
                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlType: '@',
                    controlRequired: '=',
                    controlDisabled: '=',
                    controlMinlength: '@',
                    controlMaxlength: '@',
                    form: '=',
                    controlValueChange: '=',
                    controlId: '@',
                    helpText: '@',
                    themeType: '@',
                    controlInputType:'@',
                    controlMinvalue:'@',
                    controlMaxvalue:'@',
                    controlModified:'=',
                    controlPlaceHolder:'@',
                    controlEnterKey: '&',
                    autoComplete: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {

        		        element.bind("keydown keypress", function (event) {
        		            if(event.which === 13) {
        		            	$scope.$apply(function (){
        		            		$scope.$parent.$eval(attributes.controlEnterKey);
        		                });
        		
        		                event.preventDefault();
        		            }
        		        });
                    	
                        $scope.boColor = "#BB8557";
                        $scope.controlMinlength = 0;
                        $scope.controlMaxlength = 500;
                        $scope.Error = "";
                        $scope.controlType = 'Normal';
                        $scope.textTransformation = "none";
                        $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/";
                        $scope.helpText = "";
                        $scope.showHelpText = false;
                        $scope.themeType = 'dark';
                        $scope.autoComplete = 'nope';
                        if($scope.controlInputType==null || $scope.controlInputType==undefined){
                        	$scope.controlInputType = 'text';
                        }
                        
                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }

                            if ($scope.controlType != null && $scope.controlType == 'DealRefNo' && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.split(' ').join('');
                            }
                        }

                        $scope.$watch('controlType', function(value) {
                            if (value == "ShortName") {
                                $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/";
                                $scope.textTransformation = "uppercase";
                            }
                            else if (value == "Alphanumeric" || value == "AlphanumericWithCaps") {
                                $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/";
                            }
                            else if (value == "Small") {
                                $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/";
                                $scope.textTransformation = "lowercase";
                            }
                        })

                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	//attributes.$set("required", true);
                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                                if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                            		$scope.boColor = "#00B0F0";
                            	}
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled ) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }                           
                            else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                                if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel == null || $scope.controlModel == "" || $scope.controlModel== undefined)) {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && ($scope.controlModel != null && $scope.controlModel != "" && $scope.controlModel!=undefined)){
                                	 if ($scope.form != null) {
                                		 $scope.form.$setValidity(attributes.controlId + "txtrequired", true);	 
                                	 }
                                	$scope.Error = "";
                                    if ($scope.controlDisabled) {
                                        $scope.bgColor = "#333333";
                                        if($scope.themeType=='light'){
                                        	// $scope.bgColor = "#FFFFFF";
                                        	$scope.boColor = "#BB8557";
                                        }
                                        if($scope.themeType=='light'){
                                    		$scope.bgColor = "#E0E0E0";
                                    	}
                                    } else {
                                        $scope.bgColor = "#0B0B0B";
                                        if($scope.themeType=='light'){
                                        	$scope.bgColor = "#FEFAEE";
                                        	$scope.boColor = "#BB8557";
                                        }
                                    }
                                    
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                        $scope.Error = ""
                                    }
                                    if ($scope.controlDisabled) {
                                        $scope.bgColor = "#333333";
                                        if($scope.themeType=='light'){
                                        	$scope.bgColor = "#E0E0E0";
                                        	$scope.boColor = "#C2C2C2";
                                        }
                                    } else {
                                        $scope.bgColor = "#0B0B0B";
                                        if($scope.themeType=='light'){
                                        	$scope.bgColor = "#FFFFFF";
                                        	$scope.boColor = "#C2C2C2";
                                        }
                                    }
                                    $scope.boColor = "#595959";
                                    if($scope.themeType=='light'){
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                            }
                            if ($scope.controlModel != null && $scope.controlModel != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && ($scope.controlModel == null || $scope.controlModel == "")) {
                            	if(attributes.required){
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                            	}
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !($scope.controlModel == null || $scope.controlModel == "")) {
                            	if(attributes.required){
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    }
                            	}
                                $scope.boColor = "#BB8557";
                            }
                            if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                                $scope.boColor = "#00B0F0";
                            }
                            
                        })
                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        	$scope.showHelpText = true;
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		$scope.Error = "This field cannot be left blank";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if(value!=undefined && value!='' && value!=null){
                                if($scope.controlType=="Number" || $scope.controlType=="NegativeNumber"){
                                	if(($scope.controlMinlength == $scope.controlMaxlength) && (value.length != $scope.controlMaxlength)){
                                		$scope.Error = "This field should be of " + $scope.controlMaxlength + " digits";
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else if(value.length < $scope.controlMinlength){
                                		$scope.Error = "This field should have minimum of " + $scope.controlMinlength + " digits";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length > $scope.controlMaxlength){
                                		$scope.Error = "This field should have maximum of " + $scope.controlMaxlength + " digits";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(Number(value) > Number($scope.controlMaxvalue)){
                                		$scope.Error = "Maximum value for this field is " + $scope.controlMaxvalue;
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else if(Number(value) < Number($scope.controlMinvalue)){
                                		$scope.Error = "Minimum value for this field is " + $scope.controlMinvalue;
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else{
                                		$scope.Error = "";
                                	}

                                }
                                else if($scope.controlType=="Normal" || $scope.controlType=="ShortName"  || $scope.controlType=="Small" || $scope.controlType=="Alphanumeric" || $scope.controlType=="AlphanumericWithCaps"){
                                	if(($scope.controlMinlength == $scope.controlMaxlength) && (value.length != $scope.controlMaxlength)){
                                		$scope.Error = "This field should be of " + $scope.controlMaxlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length < $scope.controlMinlength){
                                		$scope.Error = "This field should have minimum of " + $scope.controlMinlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length > $scope.controlMaxlength){
                                		$scope.Error = "This field should have maximum of " + $scope.controlMaxlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else{
                                		$scope.Error = "";
                                	}
                                }else if($scope.controlType=="Email"){
                                	var mailFormat=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;                               	
                                	if (!value.match(mailFormat)){
                                		$scope.Error = "Invalid email id";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else{
                                		var emailTextArr = value.split("@");
                                		if(emailTextArr[0]!=null && emailTextArr[0]!=undefined && emailTextArr[0].length > 64){ //standard email should have less than or equal to 64 characters before @ symbol
                                    		$scope.Error = "Invalid email id";
                                    		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    		$scope.boColor = "#FF3737";
                                		}else{
                                			$scope.Error = "";
                                		}
                                	}
                                }
                            }
                        	$scope.showHelpText = false;
                        }
                        
                        $scope.$watch('controlModel', function(value) {
                             if ($scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toString().replace(/^[^a-zA-Z0-9]+/g, '');
                            }  
                            if ($scope.controlType == "ShortName" && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toUpperCase();
                                $scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z]/g, "");
                            } else if($scope.controlType == "Small" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z0-9]/g, "");
                            	$scope.controlModel = $scope.controlModel.toLowerCase();
                            } else if($scope.controlType == "Alphanumeric" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z0-9]/g, "");
                            } else if($scope.controlType == "AlphanumericWithCaps" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z0-9]/g, "");
                            	$scope.controlModel = $scope.controlModel.toUpperCase();
                            }  else if($scope.controlType == "AlphaOnly" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z]/g, "");
                            }  else if($scope.controlType == "Email" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                                $scope.controlModel = $scope.controlModel.toLowerCase();
                            }else if($scope.controlType == "AlphaWithSpace" && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.replace(/[^a-zA-Z\s]/g, "");
                            }else if($scope.controlType == "StringWithoutComma" && $scope.controlModel != null){
                                $scope.controlModel = $scope.controlModel.replace(/(,)/gm,"");
                            }else if($scope.controlType == "StringWithoutCommaWithScriptValidation" && $scope.controlModel != null){
                            $scope.controlModel = $scope.controlModel.toString().replace(/[{}<>,]/g,''); 
                            }else if(($scope.controlType == "Number") && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.toString().replace(/[^0-9]/g, '');
                            	$scope.controlModel = $scope.controlModel.toString().replace(/(?!-)[^0-9]/g,'');
                            }
                            else if(($scope.controlType == "NegativeNumber") && $scope.controlModel != null){
                            	
                            	$scope.controlModel = $scope.controlModel.toString().replace(/(?!-)[^0-9]/g,'');
                            }
                            else if(($scope.controlType=="IPAddress") && $scope.controlModel!=null){
                            	$scope.controlModel = $scope.controlModel.replace(/[\s]/g, '');
                            	$scope.controlModel = $scope.controlModel.replace(/[^0-9.]/g, "");
                            }
                            else if(($scope.controlType == "AllowedCharsRegex") && $scope.controlModel != null){
                            	$scope.controlModel = $scope.controlModel.toString().replace(/[^a-zA-Z0-9 \[\]\(\)&\-]/g,'');   

                            }else if($scope.controlModel!=null){
                                    $scope.controlModel = $scope.controlModel.toString().replace(/[{}<>]/g,'');
                                                  
                            }  
                            
                            if ($scope.controlModel != null){
                            	if(value==undefined || value=='' || value==null){
                            		if(attributes.required != null){
                                		$scope.Error = "This field cannot be left blank";
                                   		$scope.boColor = "#FF3737";
                            		}
                                }else if($scope.controlType=="Number" || $scope.controlType=="NegativeNumber" ){
                                	if(($scope.controlMinlength == $scope.controlMaxlength) && (value.length != $scope.controlMaxlength)){
                                		$scope.Error = "This field should be of " + $scope.controlMaxlength + " digits";
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else if(value.length < $scope.controlMinlength){
                                		$scope.Error = "This field should have minimum of " + $scope.controlMinlength + " digits";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length > $scope.controlMaxlength){
                                		$scope.Error = "This field should have maximum of " + $scope.controlMaxlength + " digits";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(Number(value) > Number($scope.controlMaxvalue)){
                                		$scope.Error = "Maximum value for this field is " + $scope.controlMaxvalue;
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else if(Number(value) < Number($scope.controlMinvalue)){
                                		$scope.Error = "Minimum value for this field is " + $scope.controlMinvalue;
                                		$scope.boColor = "#FF3737";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                	}else{
                                		$scope.Error = "";
                                	}

                                }
                                else if($scope.controlType=="Normal" || $scope.controlType=="ShortName" || $scope.controlType=="Small"
                                		|| $scope.controlType=="Alphanumeric" || $scope.controlType=="AlphanumericWithCaps" || $scope.controlType=="AlphaOnly"){
                                	if(($scope.controlMinlength == $scope.controlMaxlength) && (value.length != $scope.controlMaxlength)){
                                		$scope.Error = "This field should be of " + $scope.controlMaxlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length < $scope.controlMinlength){
                                		$scope.Error = "This field should have minimum of " + $scope.controlMinlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else if(value.length > $scope.controlMaxlength){
                                		$scope.Error = "This field should have maximum of " + $scope.controlMaxlength + " characters";
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}else{
                                		$scope.Error = "";
                                	}
                                }else if($scope.controlType=="Email"){
                                	var mailFormat=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;                               	
                                	/*
									 * var mailformat =
									 * /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)/;
									 */
                                	if (!value.match(mailFormat)){
                                		$scope.Error = "Invalid email id";
                                		value = null;
                                		$scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                		$scope.boColor = "#FF3737";
                                	}
                                }
                            	//to replace non printable special characters with empty string
                            	//fixed for exposure sub type null issue in Mock env. on 9-Mar-2021 
//                            	if(value!=null && value!=undefined && value!=''){ 
//                            		$scope.controlModel = $scope.controlModel.toString().replace(/[^\x20-\x7E]/g, ''); 
//                            	}
                            }	
                            if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value == null || value == "" || value== undefined)) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value != null && value != "" && value!=undefined)){
                            	 if ($scope.form != null) {
                            		 $scope.form.$setValidity(attributes.controlId + "txtrequired", true);	 
                            	 }
                            	$scope.Error = "";
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	// $scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#BB8557";
                                    }
                                    if($scope.themeType=='light'){
                                		$scope.bgColor = "#E0E0E0";
                                	}
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    	$scope.boColor = "#BB8557";
                                    }
                                }
                                
                            } else {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    $scope.Error = ""
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                            		$scope.boColor = "#00B0F0";
                            	}
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if (attributes.required != null && (value != null && value != "")) {
                            	$scope.boColor = "#BB8557";
                            	/*
								 * if($scope.themeType=='light'){ $scope.boColor =
								 * "#FEFAEE"; }
								 */
                            	
                            }

                        });
                         $scope.$watch('controlModified', function(value) {
                        	 if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                 $scope.boColor = "#00B0F0";
                                 
                             }
                         
                         })

                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplMultilineText', ['$compile', function($compile) {
            return {
                template: '<textarea class="form-control" placeholder="{{controlPlaceHolder}}" autocomplete="nope" maxlength="{{controlMaxlength}}" ng-keypress="keyPress($event)" ng-minlength=controlMinlength ng-maxlength=controlMaxlength rows="{{controlRows}}" cols="{{controlCols}}" ng-model="controlModel" ng-disabled="controlDisabled" autocomplete="off" id="controlId" ng-change="updateModel()" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="background-color:{{bgColor}};border-color:{{boColor}};text-transform: {{textTransformation}}; max-width:100%;" ng-pattern="controlPattern" /><span ng-show="Error != null" class="help-block-error">{{Error}}</span>',
                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlType: '@',
                    controlRequired: '=',
                    controlDisabled: '=',
                    controlMinlength: '@',
                    controlMaxlength: '@',
                    controlRows: '@',
                    controlCols: '@',
                    form: '=',
                    controlValueChange: '=',
                    controlId: '=',
                    themeType: '@',
                    controlPlaceHolder:'@',
                    controlPattern:'@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {

                        $scope.boColor = "#BB8557";
                        $scope.controlMinlength = 0;
                        $scope.controlMaxlength = 500;
                        $scope.controlRows = 4;
                        $scope.controlCols = 7;
                        $scope.Error = "";
                        $scope.controlType = 'Normal';
                        $scope.textTransformation = "none";
                        /* $scope.controlPattern = '/^[^<>/]*$/';
                        $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/";
                        if(attributes.controlId == 'txtMessageContent'||attributes.controlId == 'txtDescription'){
                     	$scope.controlPattern = '^(?:(?!<\/|\/>).)+$';
                       }
                       if( $scope.controlPattern == null || $scope.controlPattern == undefined){
                        	//removed apostrohe and added the whitespace character
                       	$scope.controlPattern ='^(?:(?!<|>|\/>).)+$';
                       }*/
                        $scope.themeType = "dark";
                        $scope.allowEnter = true;
                        if(attributes.allowEnter != null && attributes.allowEnter!= undefined &&attributes.allowEnter == 'false'){
                        	$scope.allowEnter = false;
                        }
                        

                        
                        $scope.keyPress = function (event) {
                        	if(event.keyCode == 13 && $scope.allowEnter == false){
                        		event.preventDefault();
                        	}
                        }
                       
                        
                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }

                            if ($scope.controlType != null && $scope.controlType == 'DealRefNo' && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.split(' ').join('');
                            }
                        }

                        $scope.$watch('controlType', function(value) {
                            if (value == "ShortName") {
                                $scope.textTransformation = "uppercase";
                            }
                            /*
							 * else{ $scope.textTransformation = "capitalize"; }
							 */
                        })

                        $scope.$watch('controlRows', function(value) {
                            if (value != null && value != "") {
                                $scope.controlRows = value;
                            }
                            /*
							 * else{ $scope.textTransformation = "capitalize"; }
							 */
                        })

                        $scope.onFocus = function onFocus(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#FFC000";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !(value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })
                        
                        $scope.onBlur = function onBlur(value){
                        	if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		$scope.Error = "This field cannot be left blank";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                              if ($scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toString().replace(/^[^a-zA-Z0-9]+/g, '');
                            }  
                            if ($scope.controlType == "ShortName" && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toUpperCase();
                            } 
                            else if(($scope.controlType == "SMSSettings") && $scope.controlModel != null){
                                $scope.controlModel = $scope.controlModel.toString().replace(/\/>|<\/|[{}]/g,'');
                                }else{
                                     if($scope.controlModel != null){
                                      $scope.controlModel = $scope.controlModel.toString().replace(/[{}<>]/g,'');
                                     }
                                }
                            if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    $scope.Error = ""
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if (attributes.required != null && (value != null && value != "")) {
                            	$scope.boColor = "#BB8557";
                            	/*
								 * if($scope.themeType=='light'){ $scope.bgColor =
								 * "#FEFAEE"; }
								 */
                            	
                            }
                        	//to replace non printable special characters with empty string
                        	//fixed for exposure sub type null issue in Mock env. on 9-Mar-2021 
//                        	if(value!=null && value!=undefined && value!=''){ 
//                        		$scope.controlModel = $scope.controlModel.toString().replace(/[^\x20-\x7E]/g, ''); 
//                        	}
                        })

                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplNumeric', ['$compile','$filter', '$window', function($compile,$filter,$window) {
            return {
                template: '<div ng-class="{ \'input-group\' : showCurrencyCode || showPayOrReceive || showToggle }">'+
                            '<span class="input-group-btn" ng-show="showToggle">'+
                                '<button class="btn " ng-class = "{ \'btn-approve\':  toggleColor, \'btn-reject\':  !toggleColor, \'avoid-clicks\': controlDisabled }" ng-attr-style="height: 34px;" type="button" ng-click="toggleCallback({ character : toggleCharacter, toggle : toggleColor})" tabindex="-1"><i ng-attr-style="font-size: 20px;"></i></button>'+
                            '</span>'+
                            '<input type="text" class="form-control" aria-label="{{controlId}}" ng-model="controlModel" angular-currency="angularCurrency" variable-options="true"  data-m-dec = "6"  ng-disabled="controlDisabled" autocomplete="off" id="{{controlId}}" ng-change="updateModel()" ng-keypress="keyPress($event)" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" ng-attr-style="text-align:right;background-color:{{bgColor}};border-color:{{boColor}};text-transform: {{textTransformation}};" ng-pattern="{{controlPattern}}" tabindex="{{controlTabIndex}}"/>'+
                            '<span ng-show="Error != null" class="help-block-error">{{Error}}</span>'+
                            '<span ng-show="errorText != null && errorText!= \'\' && showErrorText" style="position:relative;"><span ng-show="errorText != null && errorText!= \'\' && showErrorText" class="help-block-warning-error arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 6px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black;">{{errorText}}</span></span>'+
                            '<span ng-show="(helpText != null && helpText!= \'\' && showHelpText)" style="position:relative;"><span ng-show="(helpText != null && helpText!= \'\' && showHelpText)" class="help-block-warning arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 6px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black;">{{helpText}}</span></span>{{ currencyCodeElement }}'+
                            '<span class="input-group-addon" ng-show="showCurrencyCode"><b>{{ currencyCode }}</b></span>'+
                            '<span class="input-group-btn" ng-show="showPayOrReceive">'+
                                '<button class="btn " ng-class = "{ \'btn-approve\':  controlModel >= 0, \'btn-reject\':  controlModel < 0, \'avoid-clicks\': controlDisabled }" style="height: 34px;" type="button" ng-click="negateControlModel()" tabindex="-1"><i style="font-size: 20px;"></i></button>'+
                            '</span>'+
                          '</div>',

                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlType: '@',
                    controlRequired: '=',
                    controlDisabled: '=',
                    form: '=',
                    controlValueChange: '=',
                    controlId: '@',
                    currencySymbol: '@',
                    noOfDecimals: '@',
                    controlMin: '@',
                    helpText: '@',
                    showErrorText: '=',
                    controlMax: '@',
                    angularCurrency: '@',
                    currencyCode: '@',
                    payOrReceiveCurrency: '@',
                    toggleCharacter: '@',
                    toggleColor: '@',
                    toggleCallback: '&',
                    themeType: '@',
                    controlTabIndex:'@',
                    controlModified:'=',
                   // showModification:'=',
                    controlInvalid:'='
                },
                compile: function(element, attributes) {
                    var linkFunction = function($scope, element, attributes) {

                        // $scope.showErrorText = false;
                        $scope.showHelpText = false;
                        $scope.boColor = "#BB8557";
                        $scope.currencySymbol = "";
                        $scope.Error = "";
                        $scope.controlType = 'Normal';
                        $scope.textTransformation = "none";
                        $scope.showCurrencyCode = false;
                        $scope.showPayOrReceive = false;
                        $scope.payOrReceive = 'Receive'
                        $scope.showToggle = false;
                        $scope.themeType = 'dark';
                        $scope.helpText = "";
                        $scope.errorText = "";

                        $scope.negateControlModel = function(){
                            $scope.controlModel = -1 * $scope.controlModel;
                        }

                        $scope.onFocus = function onFocus(){
                        	$scope.boColor = "#FFC000";
                        	$scope.showHelpText = true;
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		$scope.errorText = "This field cannot be left blank";
                            		if($scope.showErrorText!=true){
                            			$scope.Error = "This field cannot be left blank";
                            		}
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	if($scope.controlInvalid!=undefined && $scope.controlInvalid!=null && $scope.controlInvalid==true){
                            		$scope.boColor = "#FF3737";
                            	}else if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                            		$scope.boColor = "#00B0F0";
                            	}
                            	else{
                            		$scope.boColor = "#595959";
                                    if($scope.themeType=='light'){
                                    	$scope.boColor = "#C2C2C2";
                                    }
                            	}
                            	
                            }
                        	$scope.showHelpText = false;
                        }

                        /* $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/"; */
                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('payOrReceiveCurrency', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.faPayOrReceiveCurrency = 'fa fa-' + $filter('lowercase')($scope.payOrReceiveCurrency);
                                $scope.showPayOrReceive = true;
                                element.find("i").removeClass();
                                element.find("i").addClass($scope.faPayOrReceiveCurrency);
                            }
                        });

                        $scope.$watch('toggleCharacter', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.faPayOrReceiveCurrency = 'fa fa-' + $filter('lowercase')($scope.toggleCharacter);
                                $scope.showToggle = true;
                                element.find("i").removeClass();
                                element.find("i").addClass($scope.faPayOrReceiveCurrency);
                            }
                        });

                        $scope.$watch('toggleColor', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                $scope.bgColor = "#e2f0d9";
                                $scope.boColor = "#37a36a";
                                $scope.toggleColor = true;
                            } if (value != null && value != "" && (value == false || value == "false")) {
                                $scope.bgColor = "#ffebeb";
                                $scope.boColor = "#f34931";
                                $scope.toggleColor = false;
                            }
                        });

                        $scope.$watch('currencyCode', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.showCurrencyCode = true;
                            }
                        });

                        $scope.$watch('controlType', function(value) {
                            if (value == "ShortName") {
                                $scope.textTransformation = "uppercase";
                            }
                            /*
							 * else{ $scope.textTransformation = "capitalize"; }
							 */
                        })

                        $scope.$watch('currencySymbol', function(value) {
                            if (value != null && value != "") {
                                $scope.currencySymbol = value;

                            }
                            $scope.setAngularCurrency();
                        })
                        $scope.setAngularCurrency = function() {
                            $scope.angularCurrency = {
                                aSign: $scope.currencySymbol,
                                mDec: $scope.noOfDecimals,
                                vMin: $scope.controlMin,
                                vMax: $scope.controlMax
                            };
                        };
                        $scope.$watch('noOfDecimals', function(value) {
                            if (value != null && value != "") {
                                $scope.noOfDecimals = value;
                            }
                            $scope.setAngularCurrency();
                        })

                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                                if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                            		$scope.boColor = "#00B0F0";
                            	}                                
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	// $scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	// $scope.boColor = "#C2C2C2";
                                }
                            }
                            if(value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                               // $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                            }else if (attributes.required != null && ($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })
                        
                        $scope.keyPress = function (event) {
                        	var value = String.fromCharCode(event.which);
                        	var multiplier = 1;
                            if(value == 'm' || value == 'M'){
                            	multiplier = 1000000;
                            }
                            else if(value == 'l' || value == 'L'){
                            	multiplier = 100000;
                            }
                            else if(value == 'c' || value == 'C'){
                            	multiplier = 10000000;
                            }
                            else if(value == 'b' || value == 'B'){
                            	multiplier = 1000000000;
                            }
                            else if(value == 'k' || value == 'K'){
                            	multiplier = 1000;
                            }
                            
                            if($scope.controlModel!=null && $scope.controlModel!=undefined && multiplier != 1){
                            	$scope.controlModel = ($scope.controlModel * multiplier);
                            	$scope.$apply();
                            }

                        };
                        
                        element.bind('click', function (event) {
                            if (!$window.getSelection().toString()) {
                            	this.children[0].children[1].select();
                            }
                          });

                        $scope.$watch('controlModel', function(value) {
                            if ($scope.controlType == "ShortName" && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toUpperCase();
                            }
                            if ((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value == null || value == "" || value== undefined)) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else if((attributes.required != null || $scope.controlRequired ==true|| $scope.controlRequired =="true") && (value != null && value != "" && value!=undefined)){
                            	 if ($scope.form != null) {
                            		 $scope.form.$setValidity(attributes.controlId + "txtrequired", true);	 
                            	 }
                            	$scope.Error = "";
								$scope.errorText = "";
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	// $scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#BB8557";
                                    }
                                    if($scope.themeType=='light'){
                                		$scope.bgColor = "#E0E0E0";
                                	}
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    	$scope.boColor = "#BB8557";
                                    }
                                }
                                
                            } else {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    $scope.errorText = "";
                                    if($scope.showErrorText!=true){
                            			$scope.Error = "";
										$scope.errorText = "";
                            		}
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	// $scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	// $scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true){
                            		$scope.boColor = "#00B0F0";
                            	}  
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if (attributes.required != null && (value != null && value != "")) {
                            	$scope.boColor = "#BB8557";
                            	/*
								 * if($scope.themeType=='light'){ $scope.bgColor =
								 * "#FEFAEE"; }
								 */
                            }
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	// $scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	// $scope.boColor = "#C2C2C2";
                                }
                            }
                            if($scope.showPayOrReceive){
                                if($scope.controlModel >= 0){
                                    $scope.bgColor = "#e2f0d9";
                                    $scope.boColor = "#37a36a";
                                }else if($scope.controlModel < 0){
                                    $scope.bgColor = "#ffebeb";
                                    $scope.boColor = "#f34931";
                                }
                            }
                            if($scope.showToggle){
                                if($scope.toggleColor){
                                    $scope.bgColor = "#e2f0d9";
                                    $scope.boColor = "#37a36a";
                                }else {
                                    $scope.bgColor = "#ffebeb";
                                    $scope.boColor = "#f34931";
                                }
                            }
                        })
                        $scope.$watch('controlModified', function(value) {
                        	 if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                 $scope.boColor = "#00B0F0";
                                 
                             }
                         
                         });
                        $scope.$watch('controlInvalid', function(value) {
                       	 if ($scope.controlInvalid!=undefined && $scope.controlInvalid!=null && $scope.controlInvalid==true) {
                       		$scope.boColor = "#FF3737";
                                
                            }
                        
                        })

                    }
                    return linkFunction;
                }
            };
        }])

        .directive('csplCustomNumeric', ['$compile','$filter', '$window', function($compile,$filter,$window) {
            return {
                template: '<div class="input-group">'+
                            '<input type="text" class="form-control" ng-model="controlModel" angular-currency="angularCurrency" '+
                            'ng-disabled="controlDisabled" ng-required="controlRequired" autocomplete="off" '+
                            'id="{{controlId}}" variable-options="true"  data-m-dec = "6" '+
                            'ng-change="updateModel()" ng-keypress="keyPress($event)" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" '+
                            'ng-attr-style="text-align:right;background-color:{{bgColor}};border-color:{{boColor}};text-transform: {{textTransformation}};" '+
                            'tabindex="{{controlTabIndex}}" form="form"/>'+
                            '<span ng-show="Error != null" class="help-block-error">{{Error}}</span>'+
                          '</div>',

                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlRequired: '=',
                    controlDisabled: '=',
                    form: '=',
                    controlValueChange: '=',
                    controlId: '@',
                    currencySymbol: '@',
                    noOfDecimals: '@',
                    controlMin: '@',
                    controlMax: '@',
                    angularCurrency: '@',
                    themeType: '@',
                    controlTabIndex:'@',
                    controlModified:'='
                },
                compile: function(element, attributes) {
                    var linkFunction = function($scope, element, attributes) {

                        $scope.boColor = "#BB8557";
                        $scope.currencySymbol = "";
                        $scope.Error = "";
                        $scope.textTransformation = "none";
                        $scope.themeType = 'dark';

                        $scope.onFocus = function onFocus(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if ($scope.controlRequired != null && $scope.controlRequired != "" && ($scope.controlRequired == true || $scope.controlRequired == "true")) {
                            	$scope.boColor = "#BB8557";
                            	if((value==undefined || value=='' || value==null) && value!=0){
                            		$scope.Error = "This field cannot be left blank";
                               		$scope.boColor = "#FF3737";
                                }else{
                                    $scope.Error = "";
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                $scope.boColor = "#595959";
                                if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                    $scope.boColor = "#00B0F0";    
                                }
                                if($scope.themeType=='light'){
                                    $scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('currencySymbol', function(value) {
                            if (value != null && value != "") {
                                $scope.currencySymbol = value;

                            }
                            $scope.setAngularCurrency();
                        })

                        $scope.setAngularCurrency = function() {
                            $scope.angularCurrency = {
                                aSign: $scope.currencySymbol,
                                mDec: $scope.noOfDecimals,
                                vMin: $scope.controlMin,
                                vMax: $scope.controlMax
                            };
                        };

                        $scope.$watch('noOfDecimals', function(value) {
                            if (value != null && value != "") {
                                $scope.noOfDecimals = value;
                            }
                            $scope.setAngularCurrency();
                        })

                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                if (($scope.controlModel == null || $scope.controlModel == "") && $scope.controlModel!=0) {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                                if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                    $scope.boColor = "#00B0F0";   
                                }
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                }
                            }
                            if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                $scope.boColor = "#00B0F0";
                                
                            }
                            else if(value != null && value != "") {
                                $scope.boColor = "#595959";
                            }else if (($scope.controlRequired != null && $scope.controlRequired != "" && ($scope.controlRequired == true || $scope.controlRequired == "true")) 
                            && (($scope.controlModel == null || $scope.controlModel == "") && $scope.controlModel != 0)) {
                                $scope.boColor = "#BB8557";
                            } else if (($scope.controlRequired != null && $scope.controlRequired != "" && ($scope.controlRequired == true || $scope.controlRequired == "true")) 
                            && !(($scope.controlModel == null || $scope.controlModel == "") && $scope.controlModel != 0)) {
                                $scope.boColor = "#BB8557";
                            }
                        })
                        $scope.$watch('controlModified', function(value) {
                            if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                $scope.boColor = "#00B0F0";
                                
                            }
                        
                        });
                        
                        $scope.keyPress = function (event) {
                        	var value = String.fromCharCode(event.which);
                        	var multiplier = 1;
                            if(value == 'm' || value == 'M'){
                            	multiplier = 1000000;
                            }
                            else if(value == 'l' || value == 'L'){
                            	multiplier = 100000;
                            }
                            else if(value == 'c' || value == 'C'){
                            	multiplier = 10000000;
                            }
                            else if(value == 'b' || value == 'B'){
                            	multiplier = 1000000000;
                            }
                            else if(value == 'k' || value == 'K'){
                            	multiplier = 1000;
                            }
                            
                            if($scope.controlModel!=null && $scope.controlModel!=undefined && multiplier != 1){
                            	$scope.controlModel = ($scope.controlModel * multiplier);
                            	$scope.$apply();
                            }

                        };
                        
                        element.bind('click', function (event) {
                            if (!$window.getSelection().toString()) {
                            	this.children[0].children[1].select();
                            }
                        });
                    }
                    return linkFunction;
                }
            };
        }])

        .directive('csplMenu', function() {
            return {
                templateUrl: 'app/layouts/navbar/navbar.html',
                restrict: 'E',
            };
        })
        .directive('checklistModel', ['$parse', '$compile', '$rootScope', function($parse, $compile, $rootScope) {
            // contains
            function contains(arr, item, comparator) {
                if (angular.isArray(arr)) {
                    for (var i = arr.length; i--;) {
                        if (comparator(arr[i], item)) {
                            return true;
                        }
                    }
                }
                return false;
            }

            // add
            function add(arr, item, comparator) {
                arr = angular.isArray(arr) ? arr : [];
                if (!contains(arr, item, comparator)) {
                    arr.push(item);
                }
                return arr;
            }

            // remove
            function remove(arr, item, comparator) {
                if (angular.isArray(arr)) {
                    for (var i = arr.length; i--;) {
                        if (comparator(arr[i], item)) {
                            arr.splice(i, 1);
                            break;
                        }
                    }
                }
                return arr;
            }

            // http://stackoverflow.com/a/19228302/1458162
            function postLinkFn(scope, elem, attrs) {
                // exclude recursion, but still keep the model
                var checklistModel = attrs.checklistModel;
                attrs.$set("checklistModel", null);
                // compile with `ng-model` pointing to `checked`
                $compile(elem)(scope);
                attrs.$set("checklistModel", checklistModel);

                // getter / setter for original model
                var getter = $parse(checklistModel);
                var setter = getter.assign;
                var checklistChange = $parse(attrs.checklistChange);
                var checklistBeforeChange = $parse(attrs.checklistBeforeChange);

                // value added to list
                var value = attrs.checklistValue ? $parse(attrs.checklistValue)(scope.$parent) : attrs.value;


                var comparator = angular.equals;

                if (attrs.hasOwnProperty('checklistComparator')) {
                    if (attrs.checklistComparator[0] == '.') {
                        var comparatorExpression = attrs.checklistComparator.substring(1);
                        comparator = function(a, b) {
                            return a[comparatorExpression] === b[comparatorExpression];
                        };

                    } else {
                        comparator = $parse(attrs.checklistComparator)(scope.$parent);
                    }
                }

                // watch UI checked change
                scope.$watch(attrs.ngModel, function(newValue, oldValue) {
                    if (newValue === oldValue) {
                        return;
                    }

                    if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
                        scope[attrs.ngModel] = contains(getter(scope.$parent), value, comparator);
                        return;
                    }

                    setValueInChecklistModel(value, newValue);

                    if (checklistChange) {
                        checklistChange(scope);
                        $rootScope.$emit('gatewayApp:checklistModelChanged', {});
                    }
                });

                function setValueInChecklistModel(value, checked) {
                    var current = getter(scope.$parent);
                    if (angular.isFunction(setter)) {
                        if (checked === true) {
                            setter(scope.$parent, add(current, value, comparator));
                        } else {
                            setter(scope.$parent, remove(current, value, comparator));
                        }
                    }

                }

                // declare one function to be used for both $watch functions
                function setChecked(newArr, oldArr) {
                    if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
                        setValueInChecklistModel(value, scope[attrs.ngModel]);
                        return;
                    }
                    scope[attrs.ngModel] = contains(newArr, value, comparator);
                }

                // watch original model change
                // use the faster $watchCollection method if it's available
                if (angular.isFunction(scope.$parent.$watchCollection)) {
                    scope.$parent.$watchCollection(checklistModel, setChecked);
                } else {
                    scope.$parent.$watch(checklistModel, setChecked, true);
                }
            }

            return {
                restrict: 'A',
                priority: 1000,
                terminal: true,
                scope: true,
                compile: function(tElement, tAttrs) {
                    if ((tElement[0].tagName !== 'INPUT' || tAttrs.type !== 'checkbox') && (tElement[0].tagName !== 'MD-CHECKBOX') && (!tAttrs.btnCheckbox)) {
                        throw 'checklist-model should be applied to `input[type="checkbox"]` or `md-checkbox`.';
                    }

                    if (!tAttrs.checklistValue && !tAttrs.value) {
                        throw 'You should provide `value` or `checklist-value`.';
                    }

                    // by default ngModel is 'checked', so we set it if not
					// specified
                    if (!tAttrs.ngModel) {
                        // local scope var storing individual checkbox model
                        tAttrs.$set("ngModel", "checked");
                    }

                    return postLinkFn;
                }
            };
        }])
        .directive('csplPagination', [function() {
            return {
                template: '<uib-pagination class="pagination-sm pagination" total-items="recordCount" ng-model="controlModel" items-per-page="itemsPerPage"></uib-pagination>',
                restrict: 'E',
                scope: {
                    controlModel: '=',
                    recordCount: '=',
                    itemsPerPage: '='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {

                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplTableSearch', ['EntityPermissions', function(EntityPermissions) {
            return {
                template: '<input type="text" class="form-control search" style="border-color:#333333;" placeholder="Search" ng-model="controlModel" id="{{controlId}}" />',
                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlId: '@',
                    isSearchAlone: '='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.permissionToExport = EntityPermissions.hasPermission('CommonEntity.EXPORT');
                        if ($scope.permissionToExport && ($scope.isSearchAlone == null || $scope.isSearchAlone == false)) {
                            $scope.marginTop = '-25px';
                        } else {
                            $scope.marginTop = '0px';
                        }
                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplTableSort', [function() {
            return {
                template: '<a ng-click="sortTypeModel = sortTypeName; sortReverseModel = !sortReverseModel"><span data-translate={{headerText}}></span><span ng-show="sortTypeModel == sortTypeName && !sortReverseModel" class="fa fa-caret-down"></span><span ng-show="sortTypeModel == sortTypeName && sortReverseModel" class="fa fa-caret-up"></span></a>',
                restrict: 'E',
                scope: {
                    sortTypeModel: '=',
                    sortTypeName: '&',
                    sortReverseModel: '=',
                    defaultSort: '@defaultSort',
                    headerText: '='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {

                        $scope.sortReverseModel = false;

                        $scope.$watch('defaultSort', function(value) {
                            if (value == "desc") {
                                $scope.sortTypeModel = $scope.sortTypeName;
                                $scope.sortReverseModel = true;
                            } else if (value == "asc") {
                                $scope.sortTypeModel = $scope.sortTypeName;
                                $scope.sortReverseModel = false;
                            }
                        });
                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplTableExport', ['EntityPermissions','GlobalValues', function(EntityPermissions,GlobalValues) {
            var controllerName = 'csplTableExportCtrl';
            return {
                controller: ['$rootScope', '$scope', '$timeout', '$filter', function($rootScope, $scope, $timeout, $filter) {
                    var noOfRecordsPerPage = 0;
                    var isExportMode = false;
                    var exportOption = '';
                    var pageIndex = 1;
                    var noOfRecordsPerPageCopy=0;

                    this.exportToFile = function(option) {
                        if ($scope.totalRecordCount != null && $scope.totalRecordCount > 0) {
                            exportOption = option;
                            pageIndex = $scope.pageNo;
                            noOfRecordsPerPage = $scope.noOfRecordsPerPage;
                            noOfRecordsPerPageCopy = $scope.noOfRecordsPerPage;
                            checkAndProcessExport();
                        }
                    };

                    $rootScope.$on('gatewayApp:csplTableRepeatComplete', function(event, result) {
                        if (isExportMode && result == $scope.tableName) {
                            isExportMode = false;
                            $timeout(function() {
                                processExport();
                            });
                        }
                    });
                    function checkAndProcessExport() {
                        if (($scope.filterText == null || $scope.filterText == "") && ($scope.totalRecordCount > $scope.noOfRecordsPerPage)) {
                            $scope.noOfRecordsPerPage = $scope.totalRecordCount;
                            noOfRecordsPerPage = $scope.noOfRecordsPerPage;
                            isExportMode = true; 
                            $timeout(function() {
                                processExport();
                            });
                       } else {
                            processExport();
                        }
                    }

                    function processExport() {
                    	$scope.sheetName =  $scope.fileName;
                    	var fileName = $scope.fileName + "_"+ $filter('date')(new Date(), "dd")  + "_"+ $filter('date')(new Date(), "MMM") + "_"+
                    						$filter('date')(new Date(), "yyyy") + "_"+ $filter('date')(new Date(), "HH") + "_"+ $filter('date')(new Date(), "mm");
                    	
                        if (exportOption == 'csv') {
                            $('#' + $scope.tableName).tableExport({ type: 'csv', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn, sheetName : $scope.sheetName, footer : $scope.footer,enviromentName:GlobalValues.getEnvironmentName()});
                        } else if (exportOption == 'excel') {
                            $('#' + $scope.tableName).tableExport({ type: 'excel', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn, sheetName : $scope.sheetName, footer : $scope.footer,enviromentName:GlobalValues.getEnvironmentName()});
                        } else if (exportOption == 'pdf') {
                            $('#' + $scope.tableName).tableExport({ type: 'pdf', pdfFontSize: '7', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn});
                        } else if (exportOption == 'png') {
                            $('#' + $scope.tableName).tableExport({ type: 'png', escape: 'false',fileName : fileName,ignoreColumn : $scope.ignoreColumn });
                        } else if (exportOption == 'doc') {
                            $('#' + $scope.tableName).tableExport({ type: 'doc', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn});
                        } else if (exportOption == 'txt') {
                            $('#' + $scope.tableName).tableExport({ type: 'txt', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn});
                        } else if (exportOption == 'powerpoint') {
                            $('#' + $scope.tableName).tableExport({ type: 'powerpoint', escape: 'false' ,fileName : fileName,ignoreColumn : $scope.ignoreColumn});
                        }
                        $scope.pageNo = pageIndex;
                        $scope.noOfRecordsPerPage = noOfRecordsPerPageCopy;
                    }
                }],
                controllerAs: controllerName,
                templateUrl: 'app/csplTableExport.html',
                restrict: 'E',
                scope: {
                    tableName: '@',
                    totalRecordCount: '=',
                    noOfRecordsPerPage: '=',
                    filterText: '=',
                    pageNo: '=',
                    fileName: '@',
                    ignoreColumn : '@',
                    sheetName : '@',
                    footer: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.permissionToExport = true;
                        $scope.tableName = attributes.tableName;
                       
                        $scope.fileName = attributes.fileName;
                        $scope.sheetName = attributes.sheetName;
                        $scope.footer = attributes.footer;
                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplTableImport', ['EntityPermissions', function(EntityPermissions) {
            var controllerName = 'csplTableImportCtrl';
            return {
                controller: ['$rootScope', '$scope', '$timeout', 'ImportFile', function($rootScope, $scope, $timeout, ImportFile) {

                    this.importFile = function() {
                    	$('#uploadFile').click();
                    };

                    this.generateTemplate = function() {
                    if(($scope.uploadType) == 'BankImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    }		
                    
                    if(($scope.uploadType) == 'BranchImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }		
                    
                    if(($scope.uploadType) == 'MarkupImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    if(($scope.uploadType) == 'LimitSettingsImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    if(($scope.uploadType) == 'AMCImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    if(($scope.uploadType) == 'OneTimeRegistrationChargesImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    }
                    
                    if(($scope.uploadType) == 'GSTSettingsImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    
                    if(($scope.uploadType) == 'TransactionChargesImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    if(($scope.uploadType) == 'SwapQuotesImport') {
                    	
                    	ImportFile.generateTemplate($scope.uploadType);
                    	
                    	
                    }
                    
                    
                    };
                    
                    
                                        
                    $scope.$watch('fileContent', function(value){
                    	if(value!=null && value!=undefined){
                    		ImportFile.importFile($scope.uploadType, value);
                    		angular.element("input[type='file']").val(null);
                    	}
                    })
                    
                }],
                controllerAs: controllerName,
                templateUrl: 'app/csplTableImport.html',
                restrict: 'E',
                scope: {
                    uploadType: '@',
                    fileContent: '='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.permissionToImport = true;
                        $scope.uploadType = attributes.uploadType;
                        
                        
                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplNgRepeatEnd', ['$rootScope', function($rootScope) {
            return function(scope, element, attrs) {
                if (scope.$last) {
                    $rootScope.$emit('gatewayApp:csplTableRepeatComplete', attrs.csplNgRepeatEnd);
                }
            };
        }])
        .directive('dynamicColspan', function() {
            return {
                restrict: 'A',
                template: '',
                link: function(scope, elem, attr) {
                    function setColspan() {
                        var colsToSpan = scope.$eval(attr.dynamicColspan);
                        if (angular.isObject(colsToSpan)) {
                            angular.forEach(colsToSpan, function(condition, key) {
                                if (condition && isFinite(key)) {
                                    colsToSpan = key;
                                }
                            });
                        }

                        elem.attr('colspan', parseInt(colsToSpan, 10));
                    }
                    setColspan();
                    scope.$watch(attr.dynamicColspan, setColspan);
                }
            }
        })

        .directive('csplLegend', function () {
		    return {
		        template: '<a data-toggle="collapse" data-parent="#accordion"  data-target="#searchtab">' + '<i class = "fa" ng-class = "{\'fa-chevron-circle-down\': openBox, \'fa fa-chevron-circle-up\': \'!openBox\'}" ng-click = "openBoxFunc()" style="color: grey;"></i></a>',
		        controller: ['$scope', function ($scope) {
		            $scope.openBox = true;
		            $scope.openBoxFunc = function () {
		                $scope.openBox = !$scope.openBox;
		            }
		        }]
		    }
		})

        .directive('priceVolatilityWidget', function() {
            return {
                restrict: 'EA',
                templateUrl: 'app/widget/price-volatility-widget.html',
                scope: {
                    currencyPair: '=',
                    currentRate: '=',
                    volatilityList: '=',
                    rateList: '=',
                    priceListNoofMonth: '=',
                    pattern: '=',
                    rateDate : '='

                },
                link: function(scope, element, attributes){
                    if(scope.pattern =='pattern1')
                    	element.addClass('widget-xs-a');
                    else if(scope.pattern =='pattern2')
                    	element.addClass('widget-xs-b');
                    else if(scope.pattern =='pattern3')
                    	element.addClass('widget-xs-c');
                    else if(scope.pattern =='pattern4')
                    	element.addClass('widget-xs-d');
                  },
                controller: function() {
                    this.sparkline1options = {
                        defaultPixelsPerValue: 10,
                        width: "100%",
                        height: 30,
                        lineColor: '#fff',
                        fillColor: false,
                        spotColor: 'rgba(256, 256, 256, 0.5)',
                        minSpotColor: 'rgba(256, 256, 256, 0.5)',
                        maxSpotColor: 'rgba(256, 256, 256, 0.5)',
                        spotRadius: 3,
                        highlightSpotColor: 'rgba(256, 256, 256, 0.8)',
                        highlightLineColor: 'rgba(256, 256, 256, 0.8)',
                        lineWidth: 2
                    };
                    this.space = ' ';
                },

                controllerAs: 'priceVolatilityWidgetCtrl'
            };
        })
        .directive('csplFav', [function() {
            return {
                scope: {
                    index: '=',
                    view: '=',
                    callback: '&'
                },
                replace: true,
                template: '<a href="" data-toggle="tooltip" data-container="body" data-placement="bottom" title="Save Favorite" style="position: fixed; right: 50px; color: #fff;"><i class="fa" ng-click="callback({index:index})" ng-class="{\'fa-star-o\': !view[index], \'fa-star\': view[index]}" style="font-size:20px;"></i></a>',
                restrict: 'E',
                link: function(scope, element, attrs) {
                    $(element).hover(function() {
                        // on mouseenter
                        $(element).tooltip('show');
                    }, function() {
                        // on mouseleave
                        $(element).tooltip('hide');
                    });
                }
            }
        }]).directive('onFinishRender',['$timeout', function($timeout) {
            return {
                restrict: 'A',
                link: function(scope, element, attr) {
                    if (scope.$last === true) {
                        $timeout(function() {
                            scope.$emit(attr.onFinishRender);
                        });
                    }
                }
            }
        }])
        .directive('csplEntityLookup', ['GlobalValues', 'User', function(GlobalValues, User) {
            return {
                restrict: 'E',
                replace: false,
                scope: {
                	userEntityOwnerType: '=',
                	selectedEntityOwnerType: '=',
                	bankValue: '=',
                	branchValue: '=',
                	customerValue: "=",
                	userValue: '=',
                	userListValue: '=',
                	controlForm: '=',
                	controlClass: "@",
                	showUser:'=',
                	userLookup:'=',
                	showClearCorp:'=',
                	showTerminatedBranch:'='
                },
                templateUrl: 'app/csplEntityLookup.html',
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                    	$scope.userListValue = [];
                    	$scope.$watchGroup(['selectedEntityOwnerType', 'bankValue', 'branchValue', 'customerValue', 'userValue', 'userLookup'],  function(newValues, oldValues, scope){
							var userList = [];
							$scope.userListValue = [];
							if(newValues[4]!=null && newValues[4]!=""){
								userList.push(newValues[4].id);
								$scope.userListValue = userList;
							}else if($scope.userLookup == 'userForTurnOverReport'){
								var userEntityOwnerType = $scope.userEntityOwnerType;
								if(newValues[0]!="" && newValues[0]!=null){
									if (newValues[0]==userEntityOwnerType && userEntityOwnerType!="Branch"){
										User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType},onSuccess, onFailure);
									}else if (newValues[0]==userEntityOwnerType && userEntityOwnerType=="Branch"){
										 User.getUsersForBranchTurnOverReport({"bankId":GlobalValues.getBankId(),"branchId": GlobalValues.getBranch().id},onSuccess, onFailure);
									}else if(userEntityOwnerType=="Clearcorp" && newValues[0]=="Bank"  && (newValues[1]!="" && newValues[1]!=null) ){
										User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": newValues[1].id, entityOwnerType: 'Bank'},onSuccess, onFailure);
									}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank") && newValues[0]=="Branch" && (newValues[2]!="" && newValues[2]!=null)){
										User.getUsersForBranchTurnOverReport({"bankId":GlobalValues.getOrgId(),"branchId": newValues[2].id},onSuccess, onFailure);
									}else if((userEntityOwnerType=="Clearcorp" || userEntityOwnerType=="Bank" || userEntityOwnerType=="Branch") && (newValues[0]=="MultiUserCustomer" || newValues[0]=="SingleUserCustomer") && ( newValues[3]!="" && newValues[3]!=null)){
										 User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": newValues[3].id, entityOwnerType: newValues[0]},onSuccess, onFailure);
									}
								}else if(userEntityOwnerType=="MultiUserCustomer" || userEntityOwnerType=="SingleUserCustomer"){
									 User.getUsersByOrganisationAndEntityOwnerTypeTurnOverReport({"orgId": GlobalValues.getOrgId(), entityOwnerType: userEntityOwnerType}, onSuccess, onFailure);
								}else{
									User.getUsersForOrganisationTurnOverReport({"orgId": newValues[3].id},onSuccess, onFailure);
								}
							}else{
								
								if(newValues[0]!="" && newValues[0]!=null){
									if (newValues[0]==$scope.userEntityOwnerType && $scope.userEntityOwnerType!="Branch"){
										User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: $scope.userEntityOwnerType}, onSuccess, onFailure);
									}else if (newValues[0]==$scope.userEntityOwnerType && $scope.userEntityOwnerType=="Branch"){
										User.getAllUsersForBranch({"bankId":GlobalValues.getBankId(),"branchId": GlobalValues.getBranch().id}, onSuccess, onFailure);
									}else if($scope.userEntityOwnerType=="Clearcorp" && newValues[0]=="Bank" && (newValues[1]!="" && newValues[1]!=null)){
										User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": newValues[1].id, entityOwnerType: 'Bank'}, onSuccess, onFailure);
									}else if(($scope.userEntityOwnerType=="Clearcorp" || $scope.userEntityOwnerType=="Bank") && newValues[0]=="Branch" && (newValues[2]!="" && newValues[2]!=null)){
										User.getAllUsersForBranch({"bankId":GlobalValues.getOrgId(),"branchId": newValues[2].id}, onSuccess, onFailure);
									}else if(($scope.userEntityOwnerType=="Clearcorp" || $scope.userEntityOwnerType=="Bank" || $scope.userEntityOwnerType=="Branch") && (newValues[0]=="MultiUserCustomer" || newValues[0]=="SingleUserCustomer") && (newValues[3]!="" && newValues[3]!=null)){
										User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": newValues[3].id, entityOwnerType: newValues[0]}, onSuccess, onFailure);
									}
								}else if($scope.userEntityOwnerType=="MultiUserCustomer" || $scope.userEntityOwnerType=="SingleUserCustomer"){
									User.getAllUsersByOrganisationAndEntityOwnerType({"orgId": GlobalValues.getOrgId(), entityOwnerType: $scope.userEntityOwnerType}, onSuccess, onFailure);
								}
							}
							
							function onSuccess(result){
								if(result!=null ){
									angular.forEach(result, function(value){
										userList.push(value.id);
									})
									$scope.userListValue = userList;
								}
							}
							function onFailure(){
								
							}
                    	})
                    	
                    }
                    return linkFunction;
                }
            };
        }
        ])
        
        .directive('otpInputDirective', ['$timeout', function($timeout) {
    return {
        restrict: 'A', // restrict by attribute
        scope: {
            options: "=",
            controlDisabled: "="
        },
        template: "<div>" +
        "<input type='{{type}}' ng-repeat=\"c in characters\" autocomplete='off' ng-disabled='controlDisabled' ng-keyup='onKeyUp($index,$event)' ng-keydown='onKeyDown($index,$event)' ng-model='c.value' id='otpInput{{c.index}}' name='otpInput{{c.index}}' ng-style=\"style\" placeholder=\"{{placeholder}}\" maxlength=\"1\"  />\n" +
        "</div>",
        link: function($scope, elem) {
            var size = parseInt($scope.options.size) || 6;
            var width = 100 / (size + 1);
            var margin = width / size;
            var tmp = [],
                elementArr = [];
            var DEFAULT_COLOR = "#6f6d6d";
            // generating a random number to attach to id
            var randomNumber = Math.floor(Math.random() * 10000) + 100
            $scope.style = {
                "margin-right": margin + "%",
                "border": "none",
                "border-bottom": "2px solid",
                "border-radius": "0",
                "display": "inline-block",
                "width": width + "%",
                "text-align": "center",
                "padding": "5px 0px",
                "outline":"none",
                "box-shadow":"none",
                "background":"transparent",
                "border-color": $scope.options.style && $scope.options.style.lineColor ? $scope.options.style.lineColor : DEFAULT_COLOR,
                "color": $scope.options.style && $scope.options.style.color ? $scope.options.style.color : "blue",
                "font-size": $scope.options.style && $scope.options.style.fontSize ? scope.options.style.fontSize : "13px"
            };

            $scope.type = $scope.options.type ? $scope.options.type : "text";
            $scope.placeholder = $scope.options.placeholder && $scope.options.placeholder.length === 1 ? $scope.options.placeholder : "";

            $scope.setOtpValue = function() {
                $scope.options.value = "";
                var done = true;
                angular.forEach($scope.characters, function(v, k) {
                    if (v.value.length !== 1) {
                        done = false;
                        return false;
                    }
                    $scope.options.value = $scope.options.value + v.value;
                });
                if (done) {
                    if (typeof($scope.options.onDone) === "function") {
                        $scope.options.onDone($scope.options.value);
                    }
                }
            };

            $scope.$watch('controlDisabled', function(value){
            	$scope.controlDisabled = value;
            	if(value==false){
            		angular.forEach($scope.characters, function(val) {
            			val.value='';
                    });
            	}
            })
            
            $scope.onKeyUp = function(index, e) {
                var key = e.keyCode || e.which;
                var old = $scope.options.value;
                $scope.setOtpValue();
                if ($scope.characters[index].value.length > 0 && key !== 8 && index != size - 1) {
                    $timeout(function() {
                        elementArr[index + 1][0].focus();
                    });
                }
                if (typeof($scope.options.onChange) === "function" && old !== $scope.options.value) {
                    $scope.options.onChange($scope.options.value);
                }

            };

            $scope.onKeyDown = function(index, e) {
                var key = e.keyCode || e.which;
                if (key === 8 && $scope.characters[index].value === "" && index !== 0) {
                    $timeout(function() {
                        elementArr[index - 1][0].focus();
                    });
                }
            };

            for (var i = 0; i < size; i++) {
                tmp.push({
                    index: randomNumber + "-" + i,
                    value: ""
                });
            }
            $scope.characters = tmp;

            $timeout(function() {
                for (var i = 0; i < size; i++) {
                    elementArr.push(angular.element(document.querySelector("#otpInput" + randomNumber + "-" + i)));
                }
            });

        }
    }
}])
	.directive('modalDialog', function(){
               return {
                 restrict: 'AC',
                 link: function($scope, element) {
                     var draggableStr = "draggableModal";
                     var header = $(".modal-header", element);
                     header.on('mousedown', function(mouseDownEvent) {
                       var modalDialog = element;
                       var offset = header.offset();
                       modalDialog.addClass(draggableStr).parents().on('mousemove', function(mouseMoveEvent) {
                             $("." + draggableStr, modalDialog.parents()).offset({
                                 top: mouseMoveEvent.pageY - (mouseDownEvent.pageY - offset.top),
                                 left: mouseMoveEvent.pageX - (mouseDownEvent.pageX - offset.left)
                             });
                         }).on('mouseup', function() {
                              modalDialog.removeClass(draggableStr);
                         });
                     });   
                  }
               } 
      })
       .directive('csplTimePicker', function() {
           
            return {
                
                template: '<div class="input-group" ng-disabled="controlDisabled"> <input onkeydown="return false" name="cspl-time-picker" id="controlId" type="text" datetimepicker ng-disabled="controlDisabled" options="formatOptions"  placeholder="hh:mm A" autocomplete="off" class="form-control" ng-focus="onFocus()" ng-blur="onBlur(controlModel)"  style="text-align:right;background-color:{{bgColor}};border-color:{{boColor}};color:{{colorValue}};"  on-change="updateModel()" ng-model="controlModel" /> <span class="input-group-addon " style="border-color:{{boColor}}; background:{{bgColor}}; "> <i class="glyphicon glyphicon-time"></i></span>'+
            		 			'</div> <span ng-show="Error != null" class="help-block-error">{{Error}}</span><span ng-show="(helpText != null && showHelpText)" class="help-block">{{helpText}}</span>',
                restrict: 'E',
                scope: {
                  
                    controlRequired: '=',
                    controlModel: '=',
                    controlDisabled: '=',
                    controlValueChange: '&',
                    control24HrFormat:'=',
                    controlMinDate: '=',
                    controlMaxDate: '=',
                    form: '=',
                    controlId: '=',
                    helpText: '@',
                    themeType: '@',
                    timeZone: '=',
                    horizontalPosition: '@',
                    verticalPosition: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";
                        $scope.formatOptions = {};
                        $scope.formatOptions.widgetPositioning = {
                        		horizontal: 'auto',
                         		vertical:  'auto'
                        }
                        if($scope.horizontalPosition){
                        	
                        	$scope.formatOptions.widgetPositioning.horizontal = $scope.horizontalPosition;
                        }
                        if($scope.verticalPosition){
                       	 	
                        	$scope.formatOptions.widgetPositioning.vertical = $scope.verticalPosition;
                       }
                       
                        if($scope.control24HrFormat){
                        	$scope.formatOptions.format =  'HH:mm' ;
                        }else{
                        	$scope.formatOptions.format = 'hh:mm A' ;
                        }
                        
                        if($scope.controlMinDate){
                        	$scope.formatOptions.minDate  = $scope.controlMinDate;
                        }else{
                        	$scope.formatOptions.minDate  = moment().startOf('day');
                        }
                        
                        if($scope.controlMaxDate){
                        	$scope.formatOptions.maxDate  = $scope.controlMaxDate;
                        }else{
                        	
                        	$scope.formatOptions.maxDate = moment().endOf('day');
                        } 
                        if($scope.timeZone){
                        	$scope.formatOptions.timeZone  = $scope.timeZone;
                        }else{
                        	
                        	$scope.formatOptions.timeZone = moment.tz;
                        } 
                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                            }

                            if (value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            } else if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !(value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })

                         $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "timepickerequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#FFC000";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "timepickerequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#BB8557";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.onFocus = function(){
                        	$scope.boColor = "#FFC000";
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		// $scope.Error = "This field cannot be left
									// blank";
                            		$scope.Error = "Invalid Time";
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	$scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        }

                        $scope.$watch('controlModel', function(value) {
                        	
                        		if( typeof value == 'string'){
                        			// alert("app.module");
                        			value = moment(value, 'YYYY-MM-DD').toDate();
                        			console.log(value);
                        		}
                        		
                        	
                            if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else {
                                $scope.updateModel();
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "timepickerequired", true);
                                    $scope.Error = "";
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                                if (attributes.required != null && (value != null && value != "")) {
                                	$scope.boColor = "#BB8557";
                                	/*
									 * if($scope.themeType=='light'){
									 * $scope.bgColor = "#FEFAEE"; }
									 */
                                	
                                }
                            }
                        })

                        if (attributes.darkTheme == null) {
                            $scope.colorValue = "#F2F2F2";
                        } else {
                            $scope.colorValue = "#7F7F7F";
                        }
                        if ($scope.themeType == 'light'){
                        	$scope.colorValue = '#262626';	
                        }
                    }
                    return linkFunction;
                }
            };
        })
        .directive('csplFromToTimePicker', function() {
           
            return {
                
                template: '<div style="width:100%;">'+
							'<div style="width:50%;display:table-cell;padding-right:8px;">'+      	 
								'<cspl-time-picker control-model="fromModel" control-id="controlId" time-zone="timeZone" control-required="controlRequired" control-disabled="controlFromDisabled" control-value-change="fromControlValueChange" '+
								  ' control24HrFormat="control24HrFormat" form="form" control-min-date="minValueForFrom" control-max-date="maxValueForFrom" help-text = "{{fromHelpText}}" theme_type="{{themeType}}" ></cspl-time-picker>'+								   
							'</div>'+		  
							'<div  style="width:50%;display:table-cell;padding-left:8px;">'+    			        	 
								'<cspl-time-picker control-model="toModel" control-id="toId" time-zone="timeZone" control-required="controlRequired" control-disabled="controlToDisabled" control-value-change="toControlValueChange" '+
								  ' control24HrFormat="control24HrFormat" form="form" control-min-date="minValueForTo" control-max-date="maxValueForTo" help-text = "{{toHelpText}}" theme_type="{{themeType}}"></cspl-time-picker>'+
							'</div>'+
						'</div> ',
                restrict: 'E',
                scope: {
                  
                	fromModel: '=',
                	toModel: '=',
                	maxValueForFrom: '=?',
                	maxValueForTo: '=?',
                	minValueForFrom: '=?',
                	minValueForTo: '=?',
                	timeDifference:'=',
                	controlId: '=',
                	controlRequired: '=',
                	controlFromDisabled: '=',
                	controlToDisabled: '=',
                	control24HrFormat: '=',
                	fromControlValueChange: '&',
                	toControlValueChange: '&',
                	timeZone:  '=',
                	themeType: '@',
                	form: '=',
                	fromHelpText: '@',
                	toHelpText: '@',
                	setDefaultValues: '='
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
                        $scope.boColor = "#BB8557";
                        $scope.defaultDuration = "01:00:00";
                        if($scope.controlId){
                        	$scope.toId = $scope.controlId+'ToControl';
                        }else{
                        	$scope.controlId= "timePickerPairFromControl"
                        		$scope.toId= "timePickerPairToControl"	
                        }
                        if($scope.minValueForFrom){
                        	
                        }else{
                        	$scope.minValueForFrom  = moment().startOf('day');
                        }
                                              
                        
                        $scope.subtractDurationFromGivenValue = function(toValue) {
                        	 if(toValue !=null && toValue !=undefined && toValue != ""){
                        		 var duration = $scope.timeDifference;
                        		 if(duration==null || duration ==undefined ||  duration==""){
                        			 duration = moment.duration( $scope.defaultDuration);
                        		 }
                        		 return angular.copy(toValue).subtract(duration);
                        	 }else{
                        		 
                        		 return null;
                        	 }
                        }
                        $scope.addDurationFromGivenValue = function(fromValue) {
                       	 if(fromValue !=null && fromValue !=undefined && fromValue != ""){
                       		 var duration = $scope.timeDifference;
                       		 if(duration==null || duration ==undefined ||  duration==""){
                       			 duration = moment.duration( $scope.defaultDuration);
                       		 }
                       		 return angular.copy(fromValue).add(duration);
                       	 }else{
                       		 
                       		 return null;
                       	 }
                       }
                        if($scope.toModel != null && $scope.toModel != undefined && $scope.toModel !=""){
                           
                            $scope.fromModel =  $scope.subtractDurationFromGivenValue($scope.toModel);
                           
                        }else{
                        	if($scope.setDefaultValues){
                        		var  currentMoment = moment();
                        		$scope.toModel = angular.copy(currentMoment);                        		 
                        		$scope.fromModel =  $scope.subtractDurationFromGivenValue($scope.toModel);
                        	}
                        }
                        if(  $scope.maxValueForFrom == null || $scope.maxValueForFrom == undefined || $scope.maxValueForFrom == ""  ){
                        	if($scope.setDefaultValues)
                        		$scope.maxValueForFrom =  angular.copy($scope.fromModel);
                        	else
                        		$scope.maxValueForFrom = moment().endOf('day');
                        }
                        if( ($scope.maxValueForTo == null || $scope.maxValueForTo == undefined || $scope.maxValueForTo == "") ){
                        	if($scope.setDefaultValues)
                        		$scope.maxValueForTo =  angular.copy($scope.toModel);
                        	else
                        		$scope.maxValueForTo = moment().endOf('day');
                        }
                        $scope.$watch('fromModel', function(value) {
                        	// change to value if from value is changed
                    		if(value!=null && value!=undefined && value!='') {                    			
                    			$scope.toModel =  $scope.addDurationFromGivenValue(value);
                               
                    		}
                    })

                    }
                    return linkFunction;
                }
            };
        })
        .directive('csplNumberText', ['$compile','$filter', '$window', function($compile,$filter,$window) {
            return {
                template: '<div ng-class="{ \'input-group\' : showCurrencyCode || showPayOrReceive || showToggle }">'+
                            '<span class="input-group-btn" ng-show="showToggle">'+
                                '<button class="btn " ng-class = "{ \'btn-approve\':  toggleColor, \'btn-reject\':  !toggleColor, \'avoid-clicks\': controlDisabled }" style="height: 34px;" type="button" ng-click="toggleCallback({ character : toggleCharacter, toggle : toggleColor})" tabindex="-1"><i style="font-size: 20px;"></i></button>'+
                            '</span>'+
                            '<input type="text" class="form-control"  ng-model="controlModel" angular-currency="angularCurrency" variable-options="true"  data-m-dec = "6"  ng-disabled="controlDisabled" autocomplete="off" id="{{controlId}}" ng-change="updateModel()" ng-keypress="keyPress($event)" ng-focus="onFocus()" ng-blur="onBlur(controlModel)" style="text-align:center;background-color:{{bgColor}};border-color:#BFBFBF;text-transform: {{textTransformation}};line-height:inherit;height:inherit;font-size:inherit;width:100%;margin: 0 auto;" ng-pattern="{{controlPattern}}" tabindex="{{controlTabIndex}}"/>'+
                            '<span ng-show="Error != null" class="help-block-error">{{Error}}</span>'+
                            '<span ng-show="errorText != null && errorText!= \'\' && showErrorText" style="position:relative;"><span ng-show="errorText != null && errorText!= \'\' && showErrorText" class="help-block-warning-error arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 6px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black;">{{errorText}}</span></span>'+
                            '<span ng-show="(helpText != null && helpText!= \'\' && showHelpText)" style="position:relative;"><span ng-show="(helpText != null && helpText!= \'\' && showHelpText)" class="help-block-warning arrow-up" style="position: absolute;margin: 0px 2px 2px 0px; right: 0px; background: #ffffff; padding: 6px 1px; border-radius: 4px; border-right: 5px solid transparent; border-top: 5px solid black;">{{helpText}}</span></span>{{ currencyCodeElement }}'+
                            '<span class="input-group-addon" ng-show="showCurrencyCode"><b>{{ currencyCode }}</b></span>'+
                            '<span class="input-group-btn" ng-show="showPayOrReceive">'+
                                '<button class="btn " ng-class = "{ \'btn-approve\':  controlModel >= 0, \'btn-reject\':  controlModel < 0, \'avoid-clicks\': controlDisabled }" style="height: 34px;" type="button" ng-click="negateControlModel()" tabindex="-1"><i style="font-size: 20px;"></i></button>'+
                            '</span>'+
                          '</div>',

                restrict: 'E',
                scope: {
                    controlModel: '=',
                    controlType: '@',
                    controlRequired: '=',
                    controlDisabled: '=',
                    form: '=',
                    controlValueChange: '=',
                    controlId: '@',
                    currencySymbol: '@',
                    noOfDecimals: '@',
                    controlMin: '@',
                    helpText: '@',
                    showErrorText: '=',
                    controlMax: '@',
                    angularCurrency: '@',
                    currencyCode: '@',
                    payOrReceiveCurrency: '@',
                    toggleCharacter: '@',
                    toggleColor: '@',
                    toggleCallback: '&',
                    themeType: '@',
                    controlTabIndex:'@',
                    controlModified:'=',
                    controlInvalid:'='
                },
                compile: function(element, attributes) {
                    var linkFunction = function($scope, element, attributes) {

                        $scope.showErrorText = false;
                        $scope.showHelpText = false;
                        $scope.boColor = "#BB8557";
                        $scope.currencySymbol = "";
                        $scope.Error = "";
                        $scope.controlType = 'Normal';
                        $scope.textTransformation = "none";
                        $scope.showCurrencyCode = false;
                        $scope.showPayOrReceive = false;
                        $scope.payOrReceive = 'Receive'
                        $scope.showToggle = false;
                        $scope.themeType = 'dark';
                        $scope.helpText = "";
                        $scope.errorText = "";

                        $scope.negateControlModel = function(){
                            $scope.controlModel = -1 * $scope.controlModel;
                        }

                        $scope.onFocus = function onFocus(){
                        	$scope.boColor = "#FFC000";
                        	$scope.showHelpText = true;
                        }
                        
                        $scope.onBlur = function(value){
                            if (attributes.required != null) {
                            	$scope.boColor = "#BB8557";
                            	if(value==undefined || value=='' || value==null){
                            		$scope.errorText = "This field cannot be left blank";
                            		if($scope.showErrorText==true){
                            			$scope.Error = "This field cannot be left blank";
                            		}
                               		$scope.boColor = "#FF3737";
                                }
                            } else {
                            	if($scope.controlInvalid!=undefined && $scope.controlInvalid!=null && $scope.controlInvalid==true){
                            		$scope.boColor = "#FF3737";
                            	}else{
                            		$scope.boColor = "#595959";
                                    if($scope.themeType=='light'){
                                    	$scope.boColor = "#C2C2C2";
                                    }
                            	}
                            	
                            }
                        	$scope.showHelpText = false;
                        }

                        /* $scope.controlPattern = "/^[_'.A-Za-z0-9-]*$/"; */
                        $scope.updateModel = function() {
                            if ($scope.controlValueChange != null) {
                                $scope.controlValueChange();
                            }
                        }

                        $scope.$watch('payOrReceiveCurrency', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.faPayOrReceiveCurrency = 'fa fa-' + $filter('lowercase')($scope.payOrReceiveCurrency);
                                $scope.showPayOrReceive = true;
                                element.find("i").removeClass();
                                element.find("i").addClass($scope.faPayOrReceiveCurrency);
                            }
                        });

                        $scope.$watch('toggleCharacter', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.faPayOrReceiveCurrency = 'fa fa-' + $filter('lowercase')($scope.toggleCharacter);
                                $scope.showToggle = true;
                                element.find("i").removeClass();
                                element.find("i").addClass($scope.faPayOrReceiveCurrency);
                            }
                        });

                        $scope.$watch('toggleColor', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                $scope.bgColor = "#e2f0d9";
                                $scope.boColor = "#37a36a";
                                $scope.toggleColor = true;
                            } if (value != null && value != "" && (value == false || value == "false")) {
                                $scope.bgColor = "#ffebeb";
                                $scope.boColor = "#f34931";
                                $scope.toggleColor = false;
                            }
                        });

                        $scope.$watch('currencyCode', function(value){
                            if(value != null && value != "" && value != undefined){
                                $scope.showCurrencyCode = true;
                            }
                        });

                        $scope.$watch('controlType', function(value) {
                            if (value == "ShortName") {
                                $scope.textTransformation = "uppercase";
                            }
                            /*
							 * else{ $scope.textTransformation = "capitalize"; }
							 */
                        })

                        $scope.$watch('currencySymbol', function(value) {
                            if (value != null && value != "") {
                                $scope.currencySymbol = value;

                            }
                            $scope.setAngularCurrency();
                        })
                        $scope.setAngularCurrency = function() {
                            $scope.angularCurrency = {
                                aSign: $scope.currencySymbol,
                                mDec: $scope.noOfDecimals,
                                vMin: $scope.controlMin,
                                vMax: $scope.controlMax
                            };
                        };
                        $scope.$watch('noOfDecimals', function(value) {
                            if (value != null && value != "") {
                                $scope.noOfDecimals = value;
                            }
                            $scope.setAngularCurrency();
                        })

                        $scope.$watch('controlRequired', function(value) {
                            if (value != null && value != "" && (value == true || value == "true")) {
                                // element.attr('required');
                            	attributes.$set("required", true);

                                if ($scope.controlModel == null || $scope.controlModel == "") {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                } else {
                                    if ($scope.form != null) {
                                        $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    }
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FEFAEE";
                                    }
                                    $scope.boColor = "#BB8557";
                                }
                            } else {
                                element.removeAttr('required');
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })

                        $scope.$watch('controlDisabled', function(value) {
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if(value != null && value != "") {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                               // $scope.bgColor = "#0B0B0B";
                                $scope.boColor = "#595959";
                            }else if (attributes.required != null && ($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.boColor = "#FFC000";
                            } else if (attributes.required != null && !($scope.controlModel == null || $scope.controlModel == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                }
                                $scope.boColor = "#BB8557";
                            }
                        })
                        
                        $scope.keyPress = function (event) {
                        	var value = String.fromCharCode(event.which);
                        	var multiplier = 1;
                            if(value == 'm' || value == 'M'){
                            	multiplier = 1000000;
                            }
                            else if(value == 'l' || value == 'L'){
                            	multiplier = 100000;
                            }
                            else if(value == 'c' || value == 'C'){
                            	multiplier = 10000000;
                            }
                            else if(value == 'b' || value == 'B'){
                            	multiplier = 1000000000;
                            }
                            else if(value == 'k' || value == 'K'){
                            	multiplier = 1000;
                            }
                            
                            if($scope.controlModel!=null && $scope.controlModel!=undefined && multiplier != 1){
                            	$scope.controlModel = ($scope.controlModel * multiplier);
                            	$scope.$apply();
                            }

                        };
                        
                        element.bind('click', function (event) {
                            if (!$window.getSelection().toString()) {
                            	this.children[0].children[1].select();
                            }
                          });

                        $scope.$watch('controlModel', function(value) {
                            if ($scope.controlType == "ShortName" && $scope.controlModel != null) {
                                $scope.controlModel = $scope.controlModel.toUpperCase();
                            }
                            if (attributes.required != null && (value == null || value == "")) {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", false);
                                }
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FEFAEE";
                                }
                                $scope.boColor = "#BB8557";
                            } else {
                                if ($scope.form != null) {
                                    $scope.form.$setValidity(attributes.controlId + "txtrequired", true);
                                    $scope.errorText = "";
                                    if($scope.showErrorText!=true){
                            			$scope.Error = "";
                            		}
                                }
                                if ($scope.controlDisabled) {
                                    $scope.bgColor = "#333333";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#E0E0E0";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                } else {
                                    $scope.bgColor = "#0B0B0B";
                                    if($scope.themeType=='light'){
                                    	$scope.bgColor = "#FFFFFF";
                                    	$scope.boColor = "#C2C2C2";
                                    }
                                }
                                $scope.boColor = "#595959";
                                if($scope.themeType=='light'){
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                            if (attributes.required != null && (value != null && value != "")) {
                            	$scope.boColor = "#BB8557";
                            	/*
								 * if($scope.themeType=='light'){ $scope.bgColor =
								 * "#FEFAEE"; }
								 */
                            }
                            if($scope.showPayOrReceive){
                                if($scope.controlModel >= 0){
                                    $scope.bgColor = "#e2f0d9";
                                    $scope.boColor = "#37a36a";
                                }else if($scope.controlModel < 0){
                                    $scope.bgColor = "#ffebeb";
                                    $scope.boColor = "#f34931";
                                }
                            }
                            if($scope.showToggle){
                                if($scope.toggleColor){
                                    $scope.bgColor = "#e2f0d9";
                                    $scope.boColor = "#37a36a";
                                }else {
                                    $scope.bgColor = "#ffebeb";
                                    $scope.boColor = "#f34931";
                                }
                            }
                            if ($scope.controlDisabled) {
                                $scope.bgColor = "#333333";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#E0E0E0";
                                	$scope.boColor = "#C2C2C2";
                                }
                            } else {
                                $scope.bgColor = "#0B0B0B";
                                if($scope.themeType=='light'){
                                	$scope.bgColor = "#FFFFFF";
                                	$scope.boColor = "#C2C2C2";
                                }
                            }
                        })
                        $scope.$watch('controlModified', function(value) {
                        	 if ($scope.controlModified!=undefined && $scope.controlModified!=null && $scope.controlModified==true) {
                                 $scope.boColor = "#00B0F0";
                                 
                             }
                         
                         });
                        $scope.$watch('controlInvalid', function(value) {
                       	 if ($scope.controlInvalid!=undefined && $scope.controlInvalid!=null && $scope.controlInvalid==true) {
                       		$scope.boColor = "#FF3737";
                                
                            }
                        
                        })

                    }
                    return linkFunction;
                }
            };
        }])
        .directive('csplShortcuts', function () {
		    return function (scope, element, attrs) {
		        element.bind("keydown", function (event) {
                	var code = event.which;
                	scope.value = '';
                    
                    if(code == 38){
                    	scope.value = 'UpArrow';
                    }
                    else if(code == 40){
                    	scope.value = 'DownArrow';
                    }
                    else if(code == 107){
                    	scope.value = '+';
                    }
                    else if(code == 109){
                    	scope.value = '-';
                    }
// else if(code == 37){
// key = 'LeftArrow';
// }
// else if(code == 39){
// key = 'RightArrow';
// }
                    
                    if(scope.value != ''){
                    	scope.$eval(attrs.csplShortcuts);
 		                event.preventDefault();
                    }
                });
		        
                element.bind("keypress", function (event) {
                	scope.value = String.fromCharCode(event.which);
                    if(scope.value != ''){
                    	scope.$eval(attrs.csplShortcuts);
                    }
                });
		    };
		})
		/*
		 * .directive('combo', function () { return { restrict: 'E', template: '<select
		 * ng-model="controlModel" ng-change="changeEvent()" >' + '<option
		 * ng-value="model" ng-repeat="model in items">{{model[displayItem]}}</option></select>',
		 * replace: true, scope: { items: '=', defaultItem: '=', changeEvent:
		 * '&', displayItem: '@' }, controller: function ($scope) {
		 * console.log(displayItem); }, link: function (scope, element, attrs) {
		 * 
		 * scope.controlModel = scope.items[scope.defaultItem];
		 * scope.changeEvent = function () { //console.log("changed");
		 * console.log(scope.controlModel); } } }; })
		 */
		.directive('csplSelect', ['$compile', function($compile) {
            return {

                templateUrl: 'app/csplSelect.html',
                controllerAs: 'csplSelectCtrl',
                restrict: 'E',
                scope: {
		            items: '=',
		            defaultItem: '=',
		            changeEvent: '&',
		            displayItem: '@'
                },
                compile: function(element, attribute) {
                    var linkFunction = function($scope, element, attributes) {
    		            $scope.controlModel = $scope.items[$scope.defaultItem];
                    }
                    return linkFunction;
                }
            };
        }])
		 .directive('fileReader', function() {
		  return {
		    scope: {
		      fileReader:"="
		    },
		    link: function(scope, element) {
		      $(element).on('change', function(changeEvent) {
		        var files = changeEvent.target.files;
		        if (files.length) {
		          var r = new FileReader();
		          r.onload = function(e) {
		              var contents = e.target.result;
		              scope.$apply(function () {
		                scope.fileReader = contents;
		              });
		          };
		          
		          r.readAsText(files[0]);
		        }
		      });
		    }
		  };
		})
	   .directive('myEnter', function () {
			return function (scope, element, attrs) {
				element.bind("keydown keypress", function (event) {
            		if(event.which === 13) {
                		scope.$apply(function (){
                			scope.$eval(attrs.myEnter);
                		});

                		event.preventDefault();
            		}
        		});
    		};
		})


.directive('draggable', ['$document', function($document) {
    return {
        restrict: 'A',
        link: function(scope, elm, attrs) {
            var startX, startY, initialMouseX, initialMouseY;
            elm.css({ position: 'absolute' });

            elm.bind('mousedown', function($event) {
                startX = elm.prop('offsetLeft');
                startY = elm.prop('offsetTop');
                initialMouseX = $event.clientX;
                initialMouseY = $event.clientY;
                $document.bind('mousemove', mousemove);
                $document.bind('mouseup', mouseup);
                return false;
            });

            function mousemove($event) {
                var dx = $event.clientX - initialMouseX;
                var dy = $event.clientY - initialMouseY;
                elm.css({
                    top: startY + dy + 'px',
                    left: startX + dx + 'px'
                });
                return false;
            }

            function mouseup() {
                $document.unbind('mousemove', mousemove);
                $document.unbind('mouseup', mouseup);
            }
        }
    };
}])


        .filter('split', function() {
				return function(input, splitChar, splitIndex) {
					// do some bounds checking here to ensure it has that index
					if (input != null && input != undefined && input != '') {
						var textArr = input.toString().split(splitChar);
						if (splitIndex <= textArr.length - 1) {
							return input.toString().split(splitChar)[splitIndex];
						} else {
							return input;
						}
					} else {
						return input;
					}
				}
		})
	.config(['IdleProvider', 'KeepaliveProvider', function(IdleProvider, KeepaliveProvider) {
            // IdleProvider.idle(30); // in seconds
            // IdleProvider.timeout(2); // in seconds
            // KeepaliveProvider.interval(2); // in seconds
        }])    
        
        // used to convert money to indian formatting
         .filter('amount',function(){
        	 return function(input){
        			if (input != null && input != undefined) {
        		
        				var wholeNoPart=input.toFixed().toString();
        				var formattedAmount="";
        				var formattedAmountInReverse="";
        				var a=0;
        				var b=0;
        				var i=0;
        				if(wholeNoPart.localeCompare("0")==0 && wholeNoPart.length==1)
        					return "-";
        				for(i=((wholeNoPart.length)-1);i>=0;i--)
        					{        				
        						if(a<3)
        							{
        								formattedAmount+=wholeNoPart.charAt(i);
        								a=a+1;
        							}
        						else if(b<2)
        							{
        							 	if (b == 0) {
        							 		formattedAmount+=",";
        							 		formattedAmount+=wholeNoPart.charAt(i);      							 	
        							 		b=b+1;
        							 	}
        							 	else
        							 	{
        							 		formattedAmount+=wholeNoPart.charAt(i);       							 		
        							 		b = 0;
        							 	}
        							}
        					}
        					for(i=((formattedAmount.length)-1);i>=0;i--)
        						{
        							formattedAmountInReverse+=formattedAmount.charAt(i)
        				
        						}

        						return formattedAmountInReverse;
        				}
        	 }
         })
         
         // To replace blank if the tax is 0.00%
         .filter('percentage',function(){
        	 return function(input){
        			if (input != null && input != undefined) {
        					if((input.toString()).match(/^[0].[0]+$/))
        						return " ";
        					else
        						return input;
        						
        			}
        	 }
         })
         
         .filter('charges',function(){
        	 return function(input, chargesPercentage){
     			if ((input != null && input != undefined)&&(chargesPercentage != null && chargesPercentage != undefined)) {
     					return input + ' @ ' +  chargesPercentage + '%';    						
     			}
     	 }
      })

	.filter('round',['$filter',function ($filter) {
		    /*
			 * Use this $filter to round Numbers UP, DOWN and to his nearest
			 * neighbour. You can also use multiples
			 */
		
		    /*
			 * Usage Examples: - Round Nearest: {{ 4.4 | round }} // result is 4 -
			 * Round Up: {{ 4.4 | round:'':'up' }} // result is 5 - Round Down: {{
			 * 4.6 | round:'':'down' }} // result is 4 * Multiples - Round by
			 * multiples of 10 {{ 5 | round:10 }} // result is 10 - Round UP by
			 * multiples of 10 {{ 4 | round:10:'up' }} // result is 10 - Round
			 * DOWN by multiples of 10 {{ 6 | round:10:'down' }} // result is 0
			 */
		    return function (value, mult, dir, decimals) {
			        dir = dir || 'nearest';
			        mult = mult || Number(0.01);
			        value = !value ? 0 : Number(value);
			        if (dir === 'up') {
			        	
			            return $filter('number')(Math.ceil(Math.round(parseFloat(value) * 10000) / Math.round(parseFloat(mult) * 10000)) * mult, decimals);
			        } else if (dir === 'down') {
			        	
			            return $filter('number')(Math.floor(Math.round(parseFloat(value) * 10000) / Math.round(parseFloat(mult) * 10000)) * mult, decimals);
			        } else {
			        	
			           return $filter('number')(Math.round(Math.round(parseFloat(value) * 10000) / Math.round(parseFloat(mult) * 10000)) * mult, decimals);
			        }
			    }
		}])
        .run(run);

   
    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
  
    
})();
